import axios from "axios";
import { useCallback } from "react";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../utils/TableCustomStyles";
import PlaceholderPicture from "../../images/placeholder-profile.png";
import { Stepper, Step } from "react-form-stepper";
import "../../components/css/StepperForm.css";
import Select from "react-select";

function CustomerBranchMaster() {
  const steps = [
    "Primary Details",
    "Financial Details",
    "Banking and Accounts",
  ];
  const [activeStep, setActiveStep] = useState(0);

  const addform = useRef(null);
  const addcontactform = useRef(null);
  const addUploadsform = useRef(null);
  const addSalesUploadsform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [branchUserList, setBranchUserList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [contactDataPending, setContactDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  const [showAddCustomerContactLoader, setShowAddCustomerContactLoader] =
    useState(false);
  const [showUpdateCustomerContactLoader, setShowUpdateCustomerContactLoader] =
    useState(false);
  const [showDeleteCustomerContactLoader, setShowDeleteCustomerContactLoader] =
    useState(false);
  const [deleteCustomerContactModal, setDeleteCustomerContactModal] =
    useState(false);

  const [showDeleteUploadFilesLoader, setShowDeleteUploadFilesLoader] =
    useState(false);
  const [deleteCustomerUploadModal, setDeleteCustomerUploadModal] =
    useState(false);
  const [uploadFilesSerialNumber, setUploadFilesSerialNumber] = useState("");
  const [deleteUploadFileName, setDeleteUploadFileName] = useState("");

  const [
    showDeleteSalesUploadFilesLoader,
    setShowDeleteSalesUploadFilesLoader,
  ] = useState(false);
  const [deleteCustomerSalesUploadModal, setDeleteCustomerSalesUploadModal] =
    useState(false);
  const [salesUploadFilesSerialNumber, setSalesUploadFilesSerialNumber] =
    useState("");
  const [deleteSalesUploadFileName, setDeleteSalesUploadFileName] =
    useState("");

  const [recordForDelete, setRecordForDelete] = useState(null);

  // Add field errors - Step 0
  const [showCustomerError, setShowCustomerError] = useState(false);
  const [showPortError, setShowPortError] = useState(false);
  const [showPrimarySalesError, setShowPrimarySalesError] = useState(false);
  const [showSecondarySalesError, setShowSecondarySalesError] = useState(false);
  const [showTypeError, setShowTypeError] = useState(false);
  const [showSubtypeError, setShowSubtypeError] = useState(false);
  const [showCountryError, setShowCountryError] = useState(false);
  const [showAddressLine1Error, setShowAddressLine1Error] = useState(false);
  const [showAddressLine2Error, setShowAddressLine2Error] = useState(false);
  const [showCityError, setShowCityError] = useState(false);
  const [showPincodeError, setShowPincodeError] = useState(false);
  const [showStateError, setShowStateError] = useState(false);
  // Add field errors - Step 2
  const [showBankNameError, setShowBankNameError] = useState(false);
  const [showBankBranchError, setShowBankBranchError] = useState(false);
  const [showBankAccountNumberError, setShowBankAccountNumberError] =
    useState(false);
  const [showIfscCodeError, setShowIfscCodeError] = useState(false);
  const [showEstCertificateError, setShowEstCertificateError] = useState(false);
  const [showServiceTaxError, setShowServiceTaxError] = useState(false);
  const [showVatTaxError, setShowVatTaxError] = useState(false);
  const [showPhoneBillError, setShowPhoneBillError] = useState(false);
  const [showKycCompleteError, setShowKycCompleteError] = useState(false);
  const [showTaxSetupError, setShowTaxSetupError] = useState(false);

  // Add field errors - Step 1 India
  const [showIecNumberError, setShowIecNumberError] = useState(false);
  const [showChaLicenseNumberError, setShowChaLicenseNumberError] =
    useState(false);
  const [showMtoLicenseNumberError, setShowMtoLicenseNumberError] =
    useState(false);
  const [showPanNumberError, setShowPanNumberError] = useState(false);
  const [showServiceTaxNumberError, setShowServiceTaxNumberError] =
    useState(false);
  const [showVarTaxNumberError, setShowVarTaxNumberError] = useState(false);
  const [showTanNumberError, setShowTanNumberError] = useState(false);
  const [showGstCategoryError, setShowGstCategoryError] = useState(false);
  const [showGstinError, setShowGstinError] = useState(false);

  // Add field errors - Step 1 USA
  const [showUsaEinNumberError, setShowUsaEinNumberError] = useState(false);
  const [showUsaFmcLicenseNumberError, setShowUsaFmcLicenseNumberError] =
    useState(false);
  const [showUsaScacCodeError, setShowUsaScacCodeError] = useState(false);
  const [showUsaCustomsBondError, setShowUsaCustomsBondError] = useState(false);
  const [
    showUsaBusinessLicenseNumberError,
    setShowUsaBusinessLicenseNumberError,
  ] = useState(false);
  const [showUsaPowerOfAttorneyError, setShowUsaPowerOfAttorneyError] =
    useState(false);
  const [
    showChinaBusinessLicenseNumberError,
    setShowChinaBusinessLicenseNumberError,
  ] = useState(false);
  const [
    showChinaCustomsRegistrationNumberError,
    setShowChinaCustomsRegistrationNumberError,
  ] = useState(false);
  const [
    showChinaImportExportLicenseNumberError,
    setShowChinaImportExportLicenseNumberError,
  ] = useState(false);
  const [showFtoFilingCertificateError, setShowFtoFilingCertificateError] =
    useState(false);
  const [showUAETradeLicenseNumberError, setShowUAETradeLicenseNumberError] =
    useState(false);
  const [showUAEImportExportCodeError, setShowUAEImportExportCodeError] =
    useState(false);
  const [showUAETRNNumberError, setShowUAETRNNumberError] = useState(false);
  const [
    showUAEChamberOfCommerceCertificateError,
    setShowUAEChamberOfCommerceCertificateError,
  ] = useState(false);
  const [showSingaporeUENNumberError, setShowSingaporeUENNumberError] =
    useState(false);
  const [
    showSingaporeCustomsAccountNumberError,
    setShowSingaporeCustomsAccountNumberError,
  ] = useState(false);
  const [showSingaporeGSTNumberError, setShowSingaporeGSTNumberError] =
    useState(false);
  const [
    showSingaporeFreightForwarderPermitError,
    setShowSingaporeFreightForwarderPermitError,
  ] = useState(false);

  // Add validation summary
  const [showAddValidationError, setShowAddValidationError] = useState(false);
  const [addValidationErrorArray, setAddValidationErrorArray] = useState([]);
  const [isAddValidationErrorVisible, setIsAddValidationErrorVisible] =
    useState(false);

  // Step-level tooltip (Next button)
  const [addStepErrors, setAddStepErrors] = useState([]);
  const [isAddStepErrorVisible, setIsAddStepErrorVisible] = useState(false);

  // Contact add tooltip
  const [showContactValidationError, setShowContactValidationError] =
    useState(false);
  const [contactValidationErrorArray, setContactValidationErrorArray] =
    useState([]);
  const [isContactValidationErrorVisible, setIsContactValidationErrorVisible] =
    useState(false);

  // Contact update tooltip
  const [
    showUpdateContactValidationError,
    setShowUpdateContactValidationError,
  ] = useState(false);
  const [
    updateContactValidationErrorArray,
    setUpdateContactValidationErrorArray,
  ] = useState([]);
  const [
    isUpdateContactValidationErrorVisible,
    setIsUpdateContactValidationErrorVisible,
  ] = useState(false);

  // Update field errors
  const [showUpdateCustomerError, setShowUpdateCustomerError] = useState(false);
  const [showUpdatePortError, setShowUpdatePortError] = useState(false);
  const [showUpdatePrimarySalesError, setShowUpdatePrimarySalesError] =
    useState(false);
  const [showUpdateSecondarySalesError, setShowUpdateSecondarySalesError] =
    useState(false);
  const [showUpdateTypeError, setShowUpdateTypeError] = useState(false);
  const [showUpdateSubtypeError, setShowUpdateSubtypeError] = useState(false);
  const [showUpdateCountryError, setShowUpdateCountryError] = useState(false);
  const [showUpdateAddressLine1Error, setShowUpdateAddressLine1Error] =
    useState(false);
  const [showUpdateAddressLine2Error, setShowUpdateAddressLine2Error] =
    useState(false);
  const [showUpdateCityError, setShowUpdateCityError] = useState(false);
  const [showUpdatePincodeError, setShowUpdatePincodeError] = useState(false);
  const [showUpdateStateError, setShowUpdateStateError] = useState(false);
  const [showUpdateIecNumberError, setShowUpdateIecNumberError] =
    useState(false);
  const [showUpdateChaLicenseNumberError, setShowUpdateChaLicenseNumberError] =
    useState(false);
  const [showUpdateMtoLicenseNumberError, setShowUpdateMtoLicenseNumberError] =
    useState(false);
  const [showUpdatePanNumberError, setShowUpdatePanNumberError] =
    useState(false);
  const [showUpdateServiceTaxNumberError, setShowUpdateServiceTaxNumberError] =
    useState(false);
  const [showUpdateVarTaxNumberError, setShowUpdateVarTaxNumberError] =
    useState(false);
  const [showUpdateTanNumberError, setShowUpdateTanNumberError] =
    useState(false);
  const [showUpdateGstCategoryError, setShowUpdateGstCategoryError] =
    useState(false);
  const [showUpdateGstinError, setShowUpdateGstinError] = useState(false);
  const [showUpdateBankNameError, setShowUpdateBankNameError] = useState(false);
  const [showUpdateBankBranchError, setShowUpdateBankBranchError] =
    useState(false);
  const [
    showUpdateBankAccountNumberError,
    setShowUpdateBankAccountNumberError,
  ] = useState(false);
  const [showUpdateIfscCodeError, setShowUpdateIfscCodeError] = useState(false);
  const [showUpdateEstCertificateError, setShowUpdateEstCertificateError] =
    useState(false);
  const [showUpdateServiceTaxError, setShowUpdateServiceTaxError] =
    useState(false);
  const [showUpdateVatTaxError, setShowUpdateVatTaxError] = useState(false);
  const [showUpdatePhoneBillError, setShowUpdatePhoneBillError] =
    useState(false);
  const [showUpdateKycCompleteError, setShowUpdateKycCompleteError] =
    useState(false);
  const [showUpdateTaxSetupError, setShowUpdateTaxSetupError] = useState(false);

  // Update USA errors
  const [
    showUpdateUsaBusinessLicenseNumberError,
    setShowUpdateUsaBusinessLicenseNumberError,
  ] = useState("");
  const [showUpdateUsaEinNumberError, setShowUpdateUsaEinNumberError] =
    useState("");
  const [
    showUpdateUsaFmcLicenseNumberError,
    setShowUpdateUsaFmcLicenseNumberError,
  ] = useState("");
  const [showUpdateUsaScacCodeError, setShowUpdateUsaScacCodeError] =
    useState("");

  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  const [showCustomerDetails, setShowCustomerDetails] = useState(true);
  const [showCustomerContacts, setShowCustomerContacts] = useState(false);
  const [showCustomerUploads, setShowCustomerUploads] = useState(false);
  const [showCustomerSalesUploads, setShowCustomerSalesUploads] =
    useState(false);
  const [showCustomerUsers, setShowCustomerUsers] = useState(false);

  const [showUploadFilesLoader, setShowUploadFilesLoader] = useState(false);
  const [showSalesUploadFilesLoader, setShowSalesUploadFilesLoader] =
    useState(false);

  const [uploadFileNames, setUploadFileNames] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [salesUploadFileNames, setSalesUploadFileNames] = useState([]);
  const [salesUploadFiles, setSalesUploadFiles] = useState([]);

  const [updateId, setUpdateId] = useState("");
  const [updateCustomer, setUpdateCustomer] = useState("");
  const [updatePort, setUpdatePort] = useState("");
  const [updatePrimarySales, setUpdatePrimarySales] = useState("");
  const [updateSecondarySales, setUpdateSecondarySales] = useState("");
  const [updateCustomerType, setUpdateCustomerType] = useState("");
  const [updateSubType, setUpdateSubType] = useState("");
  const [updateCountry, setUpdateCountry] = useState("");
  const [updateCountryName, setUpdateCountryName] = useState("");
  const [updateAddressLine1, setUpdateAddressLine1] = useState("");
  const [updateAddressLine2, setUpdateAddressLine2] = useState("");
  const [updateCity, setUpdateCity] = useState("");
  const [updatePincode, setUpdatePincode] = useState("");
  const [updateState, setUpdateState] = useState("");
  const [updateIecNumber, setUpdateIecNumber] = useState("");
  const [updateChaLicenseNumber, setUpdateChaLicenseNumber] = useState("");
  const [updateMtoLicenseNumber, setUpdateMtoLicenseNumber] = useState("");
  const [updatePanNumber, setUpdatePanNumber] = useState("");
  const [updateServiceTaxNumber, setUpdateServiceTaxNumber] = useState("");
  const [updateVarTax, setUpdateVarTax] = useState("");
  const [updateTanNumber, setUpdateTanNumber] = useState("");
  const [updateWebsite, setUpdateWebsite] = useState("");
  const [updateGstCategory, setUpdateGstCategory] = useState("");
  const [updateGstin, setUpdateGstin] = useState("");
  const [updateBankName, setUpdateBankName] = useState("");
  const [updateBankBranch, setUpdateBankBranch] = useState("");
  const [updateBankAccountNumber, setUpdateBankAccountNumber] = useState("");
  const [updateIfscCode, setUpdateIfscCode] = useState("");
  const [updateEstCertificate, setUpdateEstCertificate] = useState("");
  const [updateServiceTax, setUpdateServiceTax] = useState("");
  const [updateVatTax, setUpdateVatTax] = useState("");
  const [updatePhoneBill, setUpdatePhoneBill] = useState("");
  const [updateKycComplete, setUpdateKycComplete] = useState("");
  const [updateTaxSetup, setUpdateTaxSetup] = useState("");
  const [updateOthers, setUpdateOthers] = useState("");
  const [updateUsaBusinessLicenseNumber, setUpdateUsaBusinessLicenseNumber] =
    useState("");
  const [updateUsaEinNumber, setUpdateUsaEinNumber] = useState("");
  const [updateUsaFmcLicenseNumber, setUpdateUsaFmcLicenseNumber] =
    useState("");
  const [updateUsaScacCode, setUpdateUsaScacCode] = useState("");

  const [customerContacts, setCustomerContacts] = useState([]);
  const [showUpdateContactForm, setShowUpdateContactForm] = useState(false);
  const [customerUploads, setCustomerUploads] = useState([]);
  const [customerUploadDataPending, setCustomerUploadDataPending] =
    useState(false);
  const [customerSalesUploads, setCustomerSalesUploads] = useState([]);
  const [customerSalesUploadDataPending, setCustomerSalesUploadDataPending] =
    useState(false);

  const [contactName, setContactName] = useState("");
  const [contactResponsibility, setContactResponsibility] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactMobile, setContactMobile] = useState("");
  const [contactTelephone, setContactTelephone] = useState("");
  const [contactStatus, setContactStatus] = useState("ACTIVE");
  const [contactDefault, setContactDefault] = useState("NO");
  const [contactFax, setContactFax] = useState("");

  const [showContactNameError, setShowContactNameError] = useState(false);
  const [showContactResponsibilityError, setShowContactResponsibilityError] =
    useState(false);
  const [showContactEmailError, setShowContactEmailError] = useState(false);
  const [showContactMobileError, setShowContactMobileError] = useState(false);

  const [updateContactSerialNumber, setUpdateContactSerialNumber] =
    useState("");
  const [updateContactName, setUpdateContactName] = useState("");
  const [updateContactResponsibility, setUpdateContactResponsibility] =
    useState("");
  const [updateContactEmail, setUpdateContactEmail] = useState("");
  const [updateContactMobile, setUpdateContactMobile] = useState("");
  const [updateContactTelephone, setUpdateContactTelephone] = useState("");
  const [updateContactFax, setUpdateContactFax] = useState("");
  const [updateContactStatus, setUpdateContactStatus] = useState("ACTIVE");
  const [updateContactDefault, setUpdateContactDefault] = useState("NO");

  const [showUpdateContactNameError, setShowUpdateContactNameError] =
    useState(false);
  const [
    showUpdateContactResponsibilityError,
    setShowUpdateContactResponsibilityError,
  ] = useState(false);
  const [showUpdateContactEmailError, setShowUpdateContactEmailError] =
    useState(false);
  const [showUpdateContactMobileError, setShowUpdateContactMobileError] =
    useState(false);

  // Add form state
  const [currentCustomer, setCurrentCustomer] = useState("");
  const [currentSelectedCustomer, setCurrentSelectedCustomer] = useState("");
  const [currentPort, setCurrentPort] = useState("");
  const [currentPrimarySales, setCurrentPrimarySales] = useState("");
  const [currentSecondarySales, setCurrentSecondarySales] = useState("");
  const [currentCustomerType, setCurrentCustomerType] = useState("");
  const [currentSubType, setCurrentSubType] = useState("");
  const [currentCountry, setCurrentCountry] = useState("");
  const [currentSelectedCountry, setCurrentSelectedCountry] = useState("");
  const [currentAddressLine1, setCurrentAddressLine1] = useState("");
  const [currentAddressLine2, setCurrentAddressLine2] = useState("");
  const [currentCity, setCurrentCity] = useState("");
  const [currentPincode, setCurrentPincode] = useState("");
  const [currentState, setCurrentState] = useState("");
  const [currentIecNumber, setCurrentIecNumber] = useState("");
  const [currentChaLicenseNumber, setCurrentChaLicenseNumber] = useState("");
  const [currentMtoLicenseNumber, setCurrentMtoLicenseNumber] = useState("");
  const [currentPanNumber, setCurrentPanNumber] = useState("");
  const [currentServiceTaxNumber, setCurrentServiceTaxNumber] = useState("");
  const [currentVarTaxNumber, setCurrentVarTaxNumber] = useState("");
  const [currentTanNumber, setCurrentTanNumber] = useState("");
  const [currentWebsite, setCurrentWebsite] = useState("");
  const [currentGstCategory, setCurrentGstCategory] = useState("");
  const [currentGstin, setCurrentGstin] = useState("");
  const [currentBankName, setCurrentBankName] = useState("");
  const [currentBankBranch, setCurrentBankBranch] = useState("");
  const [currentBankAccountNumber, setCurrentBankAccountNumber] = useState("");
  const [currentIfscCode, setCurrentIfscCode] = useState("");
  const [currentEstCertificate, setCurrentEstCertificate] = useState("");
  const [currentServiceTax, setCurrentServiceTax] = useState("");
  const [currentVatTax, setCurrentVatTax] = useState("");
  const [currentPhoneBill, setCurrentPhoneBill] = useState("");
  const [currentKycComplete, setCurrentKycComplete] = useState("");
  const [currentTaxSetup, setCurrentTaxSetup] = useState("");
  const [currentOthers, setCurrentOthers] = useState("");

  const [selectedCountry, setSelectedCountry] = useState("");
  const [currentUsaEinNumber, setCurrentUsaEinNumber] = useState("");
  const [currentUsaFmcLicenseNumber, setCurrentUsaFmcLicenseNumber] =
    useState("");
  const [currentUsaScacCode, setCurrentUsaScacCode] = useState("");
  const [currentUsaCustomsBond, setCurrentUsaCustomsBond] = useState("");
  const [currentUsaBusinessLicenseNumber, setCurrentUsaBusinessLicenseNumber] =
    useState("");
  const [currentUsaPowerOfAttorney, setCurrentUsaPowerOfAttorney] =
    useState("");
  const [
    currentChinaBusinessLicenseNumber,
    setCurrentChinaBusinessLicenseNumber,
  ] = useState("");
  const [
    currentChinaCustomsRegistrationNumber,
    setCurrentChinaCustomsRegistrationNumber,
  ] = useState("");
  const [
    currentChinaImportExportLicenseNumber,
    setCurrentChinaImportExportLicenseNumber,
  ] = useState("");
  const [
    currentChinaFtoFilingCertificate,
    setChinaCurrentFtoFilingCertificate,
  ] = useState("");
  const [currentUAETradeLicenseNumber, setCurrentUAETradeLicenseNumber] =
    useState("");
  const [currentUAEImportExportCode, setCurrentUAEImportExportCode] =
    useState("");
  const [currentUAETRNNumber, setCurrentUAETRNNumber] = useState("");
  const [
    currentUAEChamberOfCommerceCertificate,
    setCurrentUAEChamberOfCommerceCertificate,
  ] = useState("");
  const [currentSingaporeUENNumber, setCurrentSingaporeUENNumber] =
    useState("");
  const [
    currentSingaporeCustomsAccountNumber,
    setCurrentSingaporeCustomsAccountNumber,
  ] = useState("");
  const [currentSingaporeGSTNumber, setCurrentSingaporeGSTNumber] =
    useState("");
  const [
    currentSingaporeFreightForwarderPermit,
    setCurrentSingaporeFreightForwarderPermit,
  ] = useState("");

  // Indian compliance uniqueness check
  const [eicNumberList, setIecNumberList] = useState([]);
  const [showIecNumberExistError, setShowIecNumberExistError] = useState(false);
  const [currentIecNumberExist, setCurrentIecNumberExist] = useState(false);
  const [chaLicenseNumberList, setChaLicenseNumberList] = useState([]);
  const [showChaLicenseNumberExistError, setShowChaLicenseNumberExistError] =
    useState(false);
  const [currentChaLicenseNumberExist, setCurrentChaLicenseNumberExist] =
    useState(false);
  const [mtoLicenseNumberList, setMtoLicenseNumberList] = useState([]);
  const [showMtoLicenseNumberExistError, setShowMtoLicenseNumberExistError] =
    useState(false);
  const [currentMtoLicenseNumberExist, setCurrentMtoLicenseNumberExist] =
    useState(false);
  const [panNumberList, setPanNumberList] = useState([]);
  const [showPanNumberExistError, setShowPanNumberExistError] = useState(false);
  const [currentPanNumberExist, setCurrentPanNumberExist] = useState(false);
  const [serviceTaxNumberList, setServiceTaxNumberList] = useState([]);
  const [showServiceTaxNumberExistError, setShowServiceTaxNumberExistError] =
    useState(false);
  const [currentServiceTaxNumberExist, setCurrentServiceTaxNumberExist] =
    useState(false);
  const [varTaxNumberList, setVarTaxNumberList] = useState([]);
  const [showVarTaxNumberExistError, setShowVarTaxNumberExistError] =
    useState(false);
  const [currentVarTaxNumberExist, setCurrentVarTaxNumberExist] =
    useState(false);
  const [tanNumberList, setTanNumberList] = useState([]);
  const [showTanNumberExistError, setShowTanNumberExistError] = useState(false);
  const [currentTanNumberExist, setCurrentTanNumberExist] = useState(false);
  const [gstinList, setGstinList] = useState([]);
  const [showGstinExistError, setShowGstinExistError] = useState(false);
  const [currentGstinExist, setCurrentGstinExist] = useState(false);

  // ========== Validation Helpers ==========
  const hasAnyAddError = () =>
    showCustomerError ||
    showCountryError ||
    showPortError ||
    showPrimarySalesError ||
    showSecondarySalesError ||
    showTypeError ||
    showSubtypeError ||
    showAddressLine1Error ||
    showAddressLine2Error ||
    showCityError ||
    showPincodeError ||
    showStateError ||
    showBankNameError ||
    showBankBranchError ||
    showBankAccountNumberError ||
    showIfscCodeError ||
    showEstCertificateError ||
    showServiceTaxError ||
    showVatTaxError ||
    showPhoneBillError ||
    showKycCompleteError ||
    showTaxSetupError;

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!currentCustomer) errors.push("Customer is required");
    if (!currentCountry) errors.push("Country is required");
    if (!currentPort) errors.push("Port is required");
    if (!currentPrimarySales) errors.push("Primary Sales is required");
    if (!currentSecondarySales) errors.push("Secondary Sales is required");
    if (!currentCustomerType) errors.push("Customer Type is required");
    if (!currentSubType) errors.push("Sub Type is required");
    if (!currentAddressLine1) errors.push("Address Line 1 is required");
    if (!currentAddressLine2) errors.push("Address Line 2 is required");
    if (!currentCity) errors.push("City is required");
    if (!currentPincode) errors.push("Pincode is required");
    else if (!isNumeric(currentPincode))
      errors.push("Pincode must contain only digits");
    if (!currentState) errors.push("State is required");
    if (selectedCountry === "India" || selectedCountry === "") {
      if (!currentIecNumber) errors.push("IEC Number is required");
      if (!currentChaLicenseNumber)
        errors.push("CHA License Number is required");
      if (!currentMtoLicenseNumber)
        errors.push("MTO License Number is required");
      if (!currentPanNumber) errors.push("PAN Number is required");
      else if (!validatePan(currentPanNumber))
        errors.push("PAN Number format invalid (e.g. ABCDE1234F)");
      if (!currentServiceTaxNumber)
        errors.push("Service Tax Number is required");
      if (!currentVarTaxNumber) errors.push("VAR Tax Number is required");
      if (!currentTanNumber) errors.push("TAN Number is required");
      if (!currentGstCategory) errors.push("GST Category is required");
      if (!currentGstin) errors.push("GSTIN is required");
      else if (!validateGstin(currentGstin))
        errors.push("GSTIN format invalid (e.g. 22ABCDE1234F1Z5)");
    } else if (selectedCountry === "United States") {
      if (!currentUsaEinNumber) errors.push("EIN Number is required");
      if (!currentUsaFmcLicenseNumber)
        errors.push("FMC License Number is required");
      if (!currentUsaScacCode) errors.push("SCAC Code is required");
      if (!currentUsaBusinessLicenseNumber)
        errors.push("Business License Number is required");
    } else if (selectedCountry === "Singapore") {
      if (!currentSingaporeUENNumber) errors.push("UEN Number is required");
      if (!currentSingaporeCustomsAccountNumber)
        errors.push("Customs Account Number is required");
      if (!currentSingaporeGSTNumber) errors.push("GST Number is required");
    } else if (selectedCountry === "China") {
      if (!currentChinaBusinessLicenseNumber)
        errors.push("Business License Number is required");
      if (!currentChinaCustomsRegistrationNumber)
        errors.push("Customs Registration Number is required");
      if (!currentChinaImportExportLicenseNumber)
        errors.push("Import/Export License Number is required");
    } else if (selectedCountry === "United Arab Emirates") {
      if (!currentUAETradeLicenseNumber)
        errors.push("Trade License Number is required");
      if (!currentUAEImportExportCode)
        errors.push("Import/Export Code is required");
      if (!currentUAETRNNumber) errors.push("TRN Number is required");
    }
    if (!currentBankName) errors.push("Bank Name is required");
    if (!currentBankBranch) errors.push("Bank Branch is required");
    if (!currentBankAccountNumber)
      errors.push("Bank Account Number is required");
    else if (!isNumeric(currentBankAccountNumber))
      errors.push("Bank Account Number must contain only digits");
    if (!currentIfscCode) errors.push("IFSC Code is required");
    else if (!validateIfsc(currentIfscCode))
      errors.push("IFSC Code format invalid (e.g. SBIN0001234)");
    if (!currentEstCertificate) errors.push("EST Certificate is required");
    if (!currentServiceTax) errors.push("Service Tax is required");
    if (!currentVatTax) errors.push("VAT Tax is required");
    if (!currentPhoneBill) errors.push("Phone Bill is required");
    if (!currentKycComplete) errors.push("KYC Complete is required");
    if (!currentTaxSetup) errors.push("Tax Setup is required");
    return errors;
  };

  const hasAnyUpdateError = () =>
    showUpdateCustomerError ||
    showUpdateCountryError ||
    showUpdatePortError ||
    showUpdatePrimarySalesError ||
    showUpdateSecondarySalesError ||
    showUpdateTypeError ||
    showUpdateSubtypeError ||
    showUpdateAddressLine1Error ||
    showUpdateAddressLine2Error ||
    showUpdateCityError ||
    showUpdatePincodeError ||
    showUpdateStateError ||
    showUpdateBankNameError ||
    showUpdateBankBranchError ||
    showUpdateBankAccountNumberError ||
    showUpdateIfscCodeError ||
    showUpdateEstCertificateError ||
    showUpdateServiceTaxError ||
    showUpdateVatTaxError ||
    showUpdatePhoneBillError ||
    showUpdateKycCompleteError ||
    showUpdateTaxSetupError;

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateCustomer) errors.push("Customer is required");
    if (!updateCountry) errors.push("Country is required");
    if (!updatePort) errors.push("Port is required");
    if (!updatePrimarySales) errors.push("Primary Sales is required");
    if (!updateSecondarySales) errors.push("Secondary Sales is required");
    if (!updateCustomerType) errors.push("Customer Type is required");
    if (!updateSubType) errors.push("Sub Type is required");
    if (!updateAddressLine1) errors.push("Address Line 1 is required");
    if (!updateAddressLine2) errors.push("Address Line 2 is required");
    if (!updateCity) errors.push("City is required");
    if (!updatePincode) errors.push("Pincode is required");
    else if (!isNumeric(updatePincode))
      errors.push("Pincode must contain only digits");
    if (!updateState) errors.push("State is required");
    if (!updatePanNumber) errors.push("PAN Number is required");
    else if (!validatePan(updatePanNumber))
      errors.push("PAN Number format invalid (e.g. ABCDE1234F)");
    if (!updateGstin) errors.push("GSTIN is required");
    else if (!validateGstin(updateGstin))
      errors.push("GSTIN format invalid (e.g. 22ABCDE1234F1Z5)");
    if (!updateBankName) errors.push("Bank Name is required");
    if (!updateBankBranch) errors.push("Bank Branch is required");
    if (!updateBankAccountNumber)
      errors.push("Bank Account Number is required");
    else if (!isNumeric(updateBankAccountNumber))
      errors.push("Bank Account Number must contain only digits");
    if (!updateIfscCode) errors.push("IFSC Code is required");
    else if (!validateIfsc(updateIfscCode))
      errors.push("IFSC Code format invalid (e.g. SBIN0001234)");
    if (!updateEstCertificate) errors.push("EST Certificate is required");
    if (!updateServiceTax) errors.push("Service Tax is required");
    if (!updateVatTax) errors.push("VAT Tax is required");
    if (!updatePhoneBill) errors.push("Phone Bill is required");
    if (!updateKycComplete) errors.push("KYC Complete is required");
    if (!updateTaxSetup) errors.push("Tax Setup is required");

    // Country specific validation
    if (updateCountryName === "India" || updateCountryName === "") {
      if (!updateIecNumber) errors.push("IEC Number is required");
      if (!updateChaLicenseNumber)
        errors.push("CHA License Number is required");
      if (!updateMtoLicenseNumber)
        errors.push("MTO License Number is required");
      if (!updateServiceTaxNumber)
        errors.push("Service Tax Number is required");
      if (!updateVarTax) errors.push("VAR Tax Number is required");
      if (!updateTanNumber) errors.push("TAN Number is required");
      if (!updateGstCategory) errors.push("GST Category is required");
      if (!updateGstin) errors.push("GSTIN is required");
    } else if (updateCountryName === "United States") {
      if (!updateUsaEinNumber) errors.push("EIN Number is required");
      if (!updateUsaFmcLicenseNumber)
        errors.push("FMC License Number is required");
      if (!updateUsaScacCode) errors.push("SCAC Code is required");
      if (!updateUsaBusinessLicenseNumber)
        errors.push("Business License Number is required");
    }
    return errors;
  };

  const handleAddCheckValidationClick = () =>
    setIsAddValidationErrorVisible(!isAddValidationErrorVisible);

  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  const buildStepErrors = (step) => {
    const errors = [];
    if (step === 0) {
      if (!currentCustomer) errors.push("Customer is required");
      if (!currentCountry) errors.push("Country is required");
      if (!currentPort) errors.push("Port is required");
      if (!currentPrimarySales) errors.push("Primary Sales is required");
      if (!currentSecondarySales) errors.push("Secondary Sales is required");
      if (!currentCustomerType) errors.push("Customer Type is required");
      if (!currentSubType) errors.push("Sub Type is required");
      if (!currentAddressLine1) errors.push("Address Line 1 is required");
      if (!currentAddressLine2) errors.push("Address Line 2 is required");
      if (!currentCity) errors.push("City is required");
      if (!currentPincode) errors.push("Pincode is required");
      else if (!isNumeric(currentPincode))
        errors.push("Pincode must contain only digits");
      if (!currentState) errors.push("State is required");
    } else if (step === 1) {
      if (selectedCountry === "India" || selectedCountry === "") {
        if (!currentIecNumber) errors.push("IEC Number is required");
        if (!currentChaLicenseNumber)
          errors.push("CHA License Number is required");
        if (!currentMtoLicenseNumber)
          errors.push("MTO License Number is required");
        if (!currentPanNumber) errors.push("PAN Number is required");
        else if (!validatePan(currentPanNumber))
          errors.push("PAN Number format invalid (e.g. ABCDE1234F)");
        if (!currentServiceTaxNumber)
          errors.push("Service Tax Number is required");
        if (!currentVarTaxNumber) errors.push("VAR Tax Number is required");
        if (!currentTanNumber) errors.push("TAN Number is required");
        if (!currentGstCategory) errors.push("GST Category is required");
        if (!currentGstin) errors.push("GSTIN is required");
        else if (!validateGstin(currentGstin))
          errors.push("GSTIN format invalid (e.g. 22ABCDE1234F1Z5)");
      } else if (selectedCountry === "United States") {
        if (!currentUsaEinNumber) errors.push("EIN Number is required");
        if (!currentUsaFmcLicenseNumber)
          errors.push("FMC License Number is required");
        if (!currentUsaScacCode) errors.push("SCAC Code is required");
        if (!currentUsaBusinessLicenseNumber)
          errors.push("Business License Number is required");
      } else if (selectedCountry === "Singapore") {
        if (!currentSingaporeUENNumber) errors.push("UEN Number is required");
        if (!currentSingaporeCustomsAccountNumber)
          errors.push("Customs Account Number is required");
        if (!currentSingaporeGSTNumber) errors.push("GST Number is required");
      } else if (selectedCountry === "China") {
        if (!currentChinaBusinessLicenseNumber)
          errors.push("Business License Number is required");
        if (!currentChinaCustomsRegistrationNumber)
          errors.push("Customs Registration Number is required");
        if (!currentChinaImportExportLicenseNumber)
          errors.push("Import/Export License Number is required");
      } else if (selectedCountry === "United Arab Emirates") {
        if (!currentUAETradeLicenseNumber)
          errors.push("Trade License Number is required");
        if (!currentUAEImportExportCode)
          errors.push("Import/Export Code is required");
        if (!currentUAETRNNumber) errors.push("TRN Number is required");
      }
    } else if (step === 2) {
      if (!currentBankName) errors.push("Bank Name is required");
      if (!currentBankBranch) errors.push("Bank Branch is required");
      if (!currentBankAccountNumber)
        errors.push("Bank Account Number is required");
      else if (!isNumeric(currentBankAccountNumber))
        errors.push("Bank Account Number must contain only digits");
      if (!currentIfscCode) errors.push("IFSC Code is required");
      else if (!validateIfsc(currentIfscCode))
        errors.push("IFSC Code format invalid (e.g. SBIN0001234)");
      if (!currentEstCertificate) errors.push("EST Certificate is required");
      if (!currentServiceTax) errors.push("Service Tax is required");
      if (!currentVatTax) errors.push("VAT Tax is required");
      if (!currentPhoneBill) errors.push("Phone Bill is required");
      if (!currentKycComplete) errors.push("KYC Complete is required");
      if (!currentTaxSetup) errors.push("Tax Setup is required");
    }
    return errors;
  };

  const handleNextClick = () => {
    if (activeStep === 0) {
      setShowCustomerError(!currentCustomer);
      setShowCountryError(!currentCountry);
      setShowPortError(!currentPort);
      setShowPrimarySalesError(!currentPrimarySales);
      setShowSecondarySalesError(!currentSecondarySales);
      setShowTypeError(!currentCustomerType);
      setShowSubtypeError(!currentSubType);
      setShowAddressLine1Error(!currentAddressLine1);
      setShowAddressLine2Error(!currentAddressLine2);
      setShowCityError(!currentCity);
      setShowPincodeError(!currentPincode || !isNumeric(currentPincode));
      setShowStateError(!currentState);
    } else if (activeStep === 1) {
      if (selectedCountry === "India" || selectedCountry === "") {
        setShowIecNumberError(!currentIecNumber);
        setShowChaLicenseNumberError(!currentChaLicenseNumber);
        setShowMtoLicenseNumberError(!currentMtoLicenseNumber);
        setShowPanNumberError(
          !currentPanNumber ||
            (currentPanNumber && !validatePan(currentPanNumber)),
        );
        setShowServiceTaxNumberError(!currentServiceTaxNumber);
        setShowVarTaxNumberError(!currentVarTaxNumber);
        setShowTanNumberError(!currentTanNumber);
        setShowGstCategoryError(!currentGstCategory);
        setShowGstinError(
          !currentGstin || (currentGstin && !validateGstin(currentGstin)),
        );
      } else if (selectedCountry === "United States") {
        setShowUsaEinNumberError(!currentUsaEinNumber);
        setShowUsaFmcLicenseNumberError(!currentUsaFmcLicenseNumber);
        setShowUsaScacCodeError(!currentUsaScacCode);
        setShowUsaBusinessLicenseNumberError(!currentUsaBusinessLicenseNumber);
      } else if (selectedCountry === "Singapore") {
        setShowSingaporeUENNumberError(!currentSingaporeUENNumber);
        setShowSingaporeCustomsAccountNumberError(
          !currentSingaporeCustomsAccountNumber,
        );
        setShowSingaporeGSTNumberError(!currentSingaporeGSTNumber);
      } else if (selectedCountry === "China") {
        setShowChinaBusinessLicenseNumberError(
          !currentChinaBusinessLicenseNumber,
        );
        setShowChinaCustomsRegistrationNumberError(
          !currentChinaCustomsRegistrationNumber,
        );
        setShowChinaImportExportLicenseNumberError(
          !currentChinaImportExportLicenseNumber,
        );
      } else if (selectedCountry === "United Arab Emirates") {
        setShowUAETradeLicenseNumberError(!currentUAETradeLicenseNumber);
        setShowUAEImportExportCodeError(!currentUAEImportExportCode);
        setShowUAETRNNumberError(!currentUAETRNNumber);
      }
    }
    const errors = buildStepErrors(activeStep);
    if (errors.length > 0) {
      setAddStepErrors(errors);
      setIsAddStepErrorVisible(true);
      return;
    }
    setAddStepErrors([]);
    setIsAddStepErrorVisible(false);
    setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  };

  const buildContactErrorMessages = () => {
    const errors = [];
    if (!contactName) errors.push("Name is required");
    if (!contactResponsibility) errors.push("Responsibility is required");
    if (!contactEmail) errors.push("Email is required");
    else if (!validateEmail(contactEmail)) errors.push("Email must be valid");
    if (!contactMobile) errors.push("Mobile number is required");
    else if (!validateMobile(contactMobile))
      errors.push("Mobile must be 9–11 digits");
    return errors;
  };

  const buildUpdateContactErrorMessages = () => {
    const errors = [];
    if (!updateContactName) errors.push("Name is required");
    if (!updateContactResponsibility) errors.push("Responsibility is required");
    if (!updateContactEmail) errors.push("Email is required");
    else if (!validateEmail(updateContactEmail))
      errors.push("Email must be valid");
    if (!updateContactMobile) errors.push("Mobile number is required");
    else if (!validateMobile(updateContactMobile))
      errors.push("Mobile must be 9–11 digits");
    return errors;
  };

  const isNumeric = (val) => /^\d+$/.test(val);
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePan = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);
  const validateGstin = (gstin) =>
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstin);
  const validateIfsc = (ifsc) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc);
  const validateMobile = (mobile) => /^\d{9,11}$/.test(mobile);

  // ========== API calls ==========
  const getLoggenInUser = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      if (response) {
        setLoggedInUser(response.data);
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }, [user_id]);

  const getCustomer = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/customer/",
      );
      if (response) {
        const customer_data = response.data;
        const sorted_data = customer_data.sort((a, b) => a.name - b.name);
        const customer_name_list =
          sorted_data?.map((item) => ({ value: item.id, label: item.name })) ||
          [];
        setCustomerList(customer_name_list);
      }
    } catch (err) {
      toast.error("Error in fetching customer data! Try again.");
    }
  };

  const getIecNumber = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/customerbranch/getindiancomplicance/",
      );
      if (response) {
        setIecNumberList(response.data["eic_number_data"]);
        setChaLicenseNumberList(response.data["cha_license_number_data"]);
        setMtoLicenseNumberList(response.data["mto_license_number_data"]);
        setPanNumberList(response.data["pan_number_data"]);
        setServiceTaxNumberList(response.data["service_tax_number_data"]);
        setVarTaxNumberList(response.data["var_tax_number_data"]);
        setTanNumberList(response.data["tan_number_data"]);
        setGstinList(response.data["gstin_data"]);
      }
    } catch (err) {
      toast.error("Error in fetching indian complicance data! Try again.");
    }
  };

  const getCustomerBranch = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/customerbranch/",
      );
      if (response) {
        setData(response.data);
        setDataPending(false);
      }
    } catch (err) {
      toast.error("Error in fetching customer branch data! Try again.");
    }
  };

  const getCustomerBranchUser = async (id) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/customerbranch/getbranchuser?branch=" +
          id,
      );
      if (response) {
        setBranchUserList(response.data);
      }
    } catch (err) {
      toast.error("Error in fetching customer branch user data! Try again.");
    }
  };

  const getPort = async (country) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port?country=" + country,
      );
      const port_data = response.data;
      const sorted_data = port_data.sort((a, b) => a.name - b.name);
      setPortList(sorted_data);
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  };

  const getCountry = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/country/",
      );
      const country_data = response.data;
      const sorted_data = country_data.sort(
        (a, b) => a.object_id - b.object_id,
      );
      const country_name_list =
        sorted_data?.map((item) => ({
          value: item.id,
          label: item.long_name,
        })) || [];
      setCountryList(country_name_list);
    } catch (err) {
      toast.error("Error in fetching country data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      if (role_permissions_array) {
        setCurrentUserRolePermissionData(role_permissions_array);
      }
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggenInUser();
    getCustomer();
    getIecNumber();
    getCustomerBranch();
    getCountry();
  }, [getLoggenInUser]);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);

  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/customerbranch/" +
          id +
          "/",
      );
      setShowDeleteModal(false);
      toast.success("Record deleted successfully");
      getCustomerBranch();
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    } finally {
      setShowDeleteLoader(false);
    }
  };

  // ========== Update data setter ==========
  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateCustomer(row.customer);
    setUpdatePort(row.port);
    setUpdatePrimarySales(row.primary_sales);
    setUpdateSecondarySales(row.secondary_sales);
    setUpdateCustomerType(row.customer_type);
    setUpdateSubType(row.sub_type);
    setUpdateCountry(row.country);
    setUpdateCountryName(row.country_data?.long_name);
    setUpdateAddressLine1(row.address_line_1);
    setUpdateAddressLine2(row.address_line_2);
    setUpdateCity(row.city);
    setUpdatePincode(row.pincode);
    setUpdateState(row.state);
    setUpdateBankName(row.bank_name);
    setUpdateBankBranch(row.bank_branch);
    setUpdateBankAccountNumber(row.bank_account_number);
    setUpdateIfscCode(row.ifsc_code);
    setUpdateEstCertificate(row.est_certificate);
    setUpdateServiceTax(row.service_tax);
    setUpdateVatTax(row.vat_tax);
    setUpdatePhoneBill(row.phone_bill);
    setUpdateKycComplete(row.kyc_complete);
    setUpdateTaxSetup(row.tax_setup);
    setUpdateOthers(row.others);
    setUpdateIecNumber(row.financial_details?.iec_number);
    setUpdateChaLicenseNumber(row.financial_details?.cha_license_number);
    setUpdateMtoLicenseNumber(row.financial_details?.mto_license_number);
    setUpdatePanNumber(row.financial_details?.pan_number);
    setUpdateServiceTaxNumber(row.financial_details?.service_tax_number);
    setUpdateVarTax(row.financial_details?.var_tax_number);
    setUpdateTanNumber(row.financial_details?.tan_number);
    setUpdateWebsite(row.financial_details?.website);
    setUpdateGstCategory(row.financial_details?.gst_category);
    setUpdateGstin(row.financial_details?.gstin);
    setUpdateUsaBusinessLicenseNumber(
      row.financial_details?.usa_business_license_number,
    );
    setUpdateUsaEinNumber(row.financial_details?.usa_ein_number);
    setUpdateUsaFmcLicenseNumber(row.financial_details?.usa_fmc_license_number);
    setUpdateUsaScacCode(row.financial_details?.usa_scac_code);
    getCustomerBranchUser(row.id);
    setCustomerContacts(row.contacts?.length > 0 ? row.contacts : []);
    setContactDataPending(false);
    setCustomerUploads(row.upload_urls?.length > 0 ? row.upload_urls : []);
    setCustomerUploadDataPending(false);
    setCustomerSalesUploads(
      row.sales_upload_urls?.length > 0 ? row.sales_upload_urls : [],
    );
    setCustomerSalesUploadDataPending(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
    getPort(row.country);
  };

  // ========== Add logic ==========
  const resetAddForm = () => {
    setCurrentCustomer("");
    setCurrentSelectedCustomer("");
    setCurrentPort("");
    setCurrentPrimarySales("");
    setCurrentSecondarySales("");
    setCurrentCustomerType("");
    setCurrentSubType("");
    setCurrentCountry("");
    setCurrentSelectedCountry("");
    setCurrentAddressLine1("");
    setCurrentAddressLine2("");
    setCurrentCity("");
    setCurrentPincode("");
    setCurrentState("");
    setCurrentIecNumber("");
    setCurrentChaLicenseNumber("");
    setCurrentMtoLicenseNumber("");
    setCurrentPanNumber("");
    setCurrentServiceTaxNumber("");
    setCurrentVarTaxNumber("");
    setCurrentTanNumber("");
    setCurrentWebsite("");
    setCurrentGstCategory("");
    setCurrentGstin("");
    setCurrentBankName("");
    setCurrentBankBranch("");
    setCurrentBankAccountNumber("");
    setCurrentIfscCode("");
    setCurrentEstCertificate("");
    setCurrentServiceTax("");
    setCurrentVatTax("");
    setCurrentPhoneBill("");
    setCurrentKycComplete("");
    setCurrentTaxSetup("");
    setCurrentOthers("");
    setCurrentUsaEinNumber("");
    setCurrentUsaFmcLicenseNumber("");
    setCurrentUsaScacCode("");
    setCurrentUsaCustomsBond("");
    setCurrentUsaBusinessLicenseNumber("");
    setCurrentUsaPowerOfAttorney("");
    setCurrentSingaporeUENNumber("");
    setCurrentSingaporeCustomsAccountNumber("");
    setCurrentSingaporeGSTNumber("");
    setCurrentSingaporeFreightForwarderPermit("");
    setCurrentChinaBusinessLicenseNumber("");
    setCurrentChinaCustomsRegistrationNumber("");
    setCurrentChinaImportExportLicenseNumber("");
    setChinaCurrentFtoFilingCertificate("");
    setCurrentUAETradeLicenseNumber("");
    setCurrentUAEImportExportCode("");
    setCurrentUAETRNNumber("");
    setCurrentUAEChamberOfCommerceCertificate("");
    setSelectedCountry("");
    setActiveStep(0);
    // Reset all error states
    setShowCustomerError(false);
    setShowCountryError(false);
    setShowPortError(false);
    setShowPrimarySalesError(false);
    setShowSecondarySalesError(false);
    setShowTypeError(false);
    setShowSubtypeError(false);
    setShowAddressLine1Error(false);
    setShowAddressLine2Error(false);
    setShowCityError(false);
    setShowPincodeError(false);
    setShowStateError(false);
    setShowIecNumberError(false);
    setShowIecNumberExistError(false);
    setCurrentIecNumberExist(false);
    setShowChaLicenseNumberError(false);
    setShowChaLicenseNumberExistError(false);
    setCurrentChaLicenseNumberExist(false);
    setShowMtoLicenseNumberError(false);
    setShowMtoLicenseNumberExistError(false);
    setCurrentMtoLicenseNumberExist(false);
    setShowPanNumberError(false);
    setShowPanNumberExistError(false);
    setCurrentPanNumberExist(false);
    setShowServiceTaxNumberError(false);
    setShowServiceTaxNumberExistError(false);
    setCurrentServiceTaxNumberExist(false);
    setShowVarTaxNumberError(false);
    setShowVarTaxNumberExistError(false);
    setCurrentVarTaxNumberExist(false);
    setShowTanNumberError(false);
    setShowTanNumberExistError(false);
    setCurrentTanNumberExist(false);
    setShowGstCategoryError(false);
    setShowGstinError(false);
    setShowGstinExistError(false);
    setCurrentGstinExist(false);
    setShowBankNameError(false);
    setShowBankBranchError(false);
    setShowBankAccountNumberError(false);
    setShowIfscCodeError(false);
    setShowEstCertificateError(false);
    setShowServiceTaxError(false);
    setShowVatTaxError(false);
    setShowPhoneBillError(false);
    setShowKycCompleteError(false);
    setShowTaxSetupError(false);
    setShowUsaEinNumberError(false);
    setShowUsaFmcLicenseNumberError(false);
    setShowUsaScacCodeError(false);
    setShowUsaBusinessLicenseNumberError(false);
    setShowSingaporeUENNumberError(false);
    setShowSingaporeCustomsAccountNumberError(false);
    setShowSingaporeGSTNumberError(false);
    setShowChinaBusinessLicenseNumberError(false);
    setShowChinaCustomsRegistrationNumberError(false);
    setShowChinaImportExportLicenseNumberError(false);
    setShowUAETradeLicenseNumberError(false);
    setShowUAEImportExportCodeError(false);
    setShowUAETRNNumberError(false);
    setShowAddValidationError(false);
    setAddValidationErrorArray([]);
    setIsAddValidationErrorVisible(false);
    setAddStepErrors([]);
    setIsAddStepErrorVisible(false);
  };

  const resetUpdateErrors = () => {
    setShowUpdateCustomerError(false);
    setShowUpdateCountryError(false);
    setShowUpdatePortError(false);
    setShowUpdatePrimarySalesError(false);
    setShowUpdateSecondarySalesError(false);
    setShowUpdateTypeError(false);
    setShowUpdateSubtypeError(false);
    setShowUpdateAddressLine1Error(false);
    setShowUpdateAddressLine2Error(false);
    setShowUpdateCityError(false);
    setShowUpdatePincodeError(false);
    setShowUpdateStateError(false);
    setShowUpdateIecNumberError(false);
    setShowUpdateChaLicenseNumberError(false);
    setShowUpdateMtoLicenseNumberError(false);
    setShowUpdatePanNumberError(false);
    setShowUpdateServiceTaxNumberError(false);
    setShowUpdateVarTaxNumberError(false);
    setShowUpdateTanNumberError(false);
    setShowUpdateGstCategoryError(false);
    setShowUpdateGstinError(false);
    setShowUpdateBankNameError(false);
    setShowUpdateBankBranchError(false);
    setShowUpdateBankAccountNumberError(false);
    setShowUpdateIfscCodeError(false);
    setShowUpdateEstCertificateError(false);
    setShowUpdateServiceTaxError(false);
    setShowUpdateVatTaxError(false);
    setShowUpdatePhoneBillError(false);
    setShowUpdateKycCompleteError(false);
    setShowUpdateTaxSetupError(false);
    setShowUpdateUsaEinNumberError(false);
    setShowUpdateUsaFmcLicenseNumberError(false);
    setShowUpdateUsaScacCodeError(false);
    setShowUpdateUsaBusinessLicenseNumberError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
  };

  const addNewCustomer = async (e) => {
    e.preventDefault();

    setShowCustomerError(!currentCustomer);
    setShowCountryError(!currentCountry);
    setShowPortError(!currentPort);
    setShowPrimarySalesError(!currentPrimarySales);
    setShowSecondarySalesError(!currentSecondarySales);
    setShowTypeError(!currentCustomerType);
    setShowSubtypeError(!currentSubType);
    setShowAddressLine1Error(!currentAddressLine1);
    setShowAddressLine2Error(!currentAddressLine2);
    setShowCityError(!currentCity);
    setShowPincodeError(!currentPincode || !isNumeric(currentPincode));
    setShowStateError(!currentState);
    setShowBankNameError(!currentBankName);
    setShowBankBranchError(!currentBankBranch);
    setShowBankAccountNumberError(
      !currentBankAccountNumber || !isNumeric(currentBankAccountNumber),
    );
    setShowIfscCodeError(!currentIfscCode || !validateIfsc(currentIfscCode));
    setShowEstCertificateError(!currentEstCertificate);
    setShowServiceTaxError(!currentServiceTax);
    setShowVatTaxError(!currentVatTax);
    setShowPhoneBillError(!currentPhoneBill);
    setShowKycCompleteError(!currentKycComplete);
    setShowTaxSetupError(!currentTaxSetup);

    if (selectedCountry === "India" || selectedCountry === "") {
      setShowIecNumberError(!currentIecNumber);
      setShowChaLicenseNumberError(!currentChaLicenseNumber);
      setShowMtoLicenseNumberError(!currentMtoLicenseNumber);
      setShowPanNumberError(
        !currentPanNumber ||
          (currentPanNumber && !validatePan(currentPanNumber)),
      );
      setShowServiceTaxNumberError(!currentServiceTaxNumber);
      setShowVarTaxNumberError(!currentVarTaxNumber);
      setShowTanNumberError(!currentTanNumber);
      setShowGstCategoryError(!currentGstCategory);
      setShowGstinError(
        !currentGstin || (currentGstin && !validateGstin(currentGstin)),
      );
    } else if (selectedCountry === "United States") {
      setShowUsaEinNumberError(!currentUsaEinNumber);
      setShowUsaFmcLicenseNumberError(!currentUsaFmcLicenseNumber);
      setShowUsaScacCodeError(!currentUsaScacCode);
      setShowUsaBusinessLicenseNumberError(!currentUsaBusinessLicenseNumber);
    } else if (selectedCountry === "Singapore") {
      setShowSingaporeUENNumberError(!currentSingaporeUENNumber);
      setShowSingaporeCustomsAccountNumberError(
        !currentSingaporeCustomsAccountNumber,
      );
      setShowSingaporeGSTNumberError(!currentSingaporeGSTNumber);
    } else if (selectedCountry === "China") {
      setShowChinaBusinessLicenseNumberError(
        !currentChinaBusinessLicenseNumber,
      );
      setShowChinaCustomsRegistrationNumberError(
        !currentChinaCustomsRegistrationNumber,
      );
      setShowChinaImportExportLicenseNumberError(
        !currentChinaImportExportLicenseNumber,
      );
    } else if (selectedCountry === "United Arab Emirates") {
      setShowUAETradeLicenseNumberError(!currentUAETradeLicenseNumber);
      setShowUAEImportExportCodeError(!currentUAEImportExportCode);
      setShowUAETRNNumberError(!currentUAETRNNumber);
    }

    setAddValidationErrorArray(buildAddErrorMessages());

    const countryFieldsInvalid =
      ((selectedCountry === "India" || selectedCountry === "") &&
        (!currentIecNumber ||
          !currentChaLicenseNumber ||
          !currentMtoLicenseNumber ||
          !currentPanNumber ||
          !validatePan(currentPanNumber) ||
          !currentServiceTaxNumber ||
          !currentVarTaxNumber ||
          !currentTanNumber ||
          !currentGstCategory ||
          !currentGstin ||
          !validateGstin(currentGstin))) ||
      (selectedCountry === "United States" &&
        (!currentUsaEinNumber ||
          !currentUsaFmcLicenseNumber ||
          !currentUsaScacCode ||
          !currentUsaBusinessLicenseNumber)) ||
      (selectedCountry === "Singapore" &&
        (!currentSingaporeUENNumber ||
          !currentSingaporeCustomsAccountNumber ||
          !currentSingaporeGSTNumber)) ||
      (selectedCountry === "China" &&
        (!currentChinaBusinessLicenseNumber ||
          !currentChinaCustomsRegistrationNumber ||
          !currentChinaImportExportLicenseNumber)) ||
      (selectedCountry === "United Arab Emirates" &&
        (!currentUAETradeLicenseNumber ||
          !currentUAEImportExportCode ||
          !currentUAETRNNumber));

    if (
      !currentCustomer ||
      !currentCountry ||
      !currentPort ||
      !currentPrimarySales ||
      !currentSecondarySales ||
      !currentCustomerType ||
      !currentSubType ||
      !currentAddressLine1 ||
      !currentAddressLine2 ||
      !currentCity ||
      !currentPincode ||
      !isNumeric(currentPincode) ||
      !currentState ||
      !currentBankName ||
      !currentBankBranch ||
      !currentBankAccountNumber ||
      !isNumeric(currentBankAccountNumber) ||
      !currentIfscCode ||
      !validateIfsc(currentIfscCode) ||
      !currentEstCertificate ||
      !currentServiceTax ||
      !currentVatTax ||
      !currentPhoneBill ||
      !currentKycComplete ||
      !currentTaxSetup ||
      countryFieldsInvalid
    ) {
      setShowAddValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const payload = {
      customer: currentCustomer,
      port: currentPort,
      primary_sales: currentPrimarySales,
      secondary_sales: currentSecondarySales,
      customer_type: currentCustomerType,
      sub_type: currentSubType,
      country: currentCountry,
      address_line_1: currentAddressLine1,
      address_line_2: currentAddressLine2,
      city: currentCity,
      pincode: currentPincode,
      state: currentState,
      bank_name: currentBankName,
      bank_branch: currentBankBranch,
      bank_account_number: currentBankAccountNumber,
      ifsc_code: currentIfscCode,
      est_certificate: currentEstCertificate,
      service_tax: currentServiceTax,
      vat_tax: currentVarTaxNumber,
      phone_bill: currentPhoneBill,
      kyc_complete: currentKycComplete,
      tax_setup: currentTaxSetup,
      others: currentOthers,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    if (selectedCountry === "India" || selectedCountry === "") {
      payload["financial_details"] = {
        iec_number: currentIecNumber,
        cha_license_number: currentChaLicenseNumber,
        mto_license_number: currentMtoLicenseNumber,
        pan_number: currentPanNumber,
        service_tax_number: currentServiceTaxNumber,
        var_tax_number: currentVarTaxNumber,
        tan_number: currentTanNumber,
        website: currentWebsite,
        gst_category: currentGstCategory,
        gstin: currentGstin,
      };
    } else if (selectedCountry === "United States") {
      payload["usa_customs_bond"] = currentUsaCustomsBond;
      payload["usa_power_of_attorney"] = currentUsaPowerOfAttorney;
      payload["financial_details"] = {
        usa_ein_number: currentUsaEinNumber,
        usa_fmc_license_number: currentUsaFmcLicenseNumber,
        usa_scac_code: currentUsaScacCode,
        usa_business_license_number: currentUsaBusinessLicenseNumber,
      };
    } else if (selectedCountry === "Singapore") {
      payload["singapore_freight_forwarder_permit"] =
        currentSingaporeFreightForwarderPermit;
      payload["financial_details"] = {
        singapore_uen_number: currentSingaporeUENNumber,
        singapore_customs_account_number: currentSingaporeCustomsAccountNumber,
        singapore_gst_number: currentSingaporeGSTNumber,
        singapore_freight_forwarder_permit:
          currentSingaporeFreightForwarderPermit,
      };
    } else if (selectedCountry === "China") {
      payload["china_fto_filing_certificate"] =
        currentChinaFtoFilingCertificate;
      payload["financial_details"] = {
        china_business_license_number: currentChinaBusinessLicenseNumber,
        china_customs_registration_number:
          currentChinaCustomsRegistrationNumber,
        china_import_export_number: currentChinaImportExportLicenseNumber,
      };
    } else if (selectedCountry === "United Arab Emirates") {
      payload["uae_chamber_of_commerce_certificate"] =
        currentUAEChamberOfCommerceCertificate;
      payload["financial_details"] = {
        uae_trade_license_number: currentUAETradeLicenseNumber,
        uae_import_export_code: currentUAEImportExportCode,
        uae_trn_number: currentUAETRNNumber,
      };
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/customerbranch/createcustomerbranch/",
        payload,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (response.status === 200) {
        toast.success("Customer Branch Created Successfully");
        resetAddForm();
        getCustomerBranch();
        setShowAddCanvas(false);
      }
    } catch (err) {
      toast.error("Error creating customer branch! Try again.");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic ==========
  const updateCustomerDetails = async (e) => {
    e.preventDefault();

    setShowUpdateCustomerError(!updateCustomer);
    setShowUpdatePortError(!updatePort);
    setShowUpdatePrimarySalesError(!updatePrimarySales);
    setShowUpdateSecondarySalesError(!updateSecondarySales);
    setShowUpdateTypeError(!updateCustomerType);
    setShowUpdateSubtypeError(!updateSubType);
    setShowUpdateCountryError(!updateCountry);
    setShowUpdateAddressLine1Error(!updateAddressLine1);
    setShowUpdateAddressLine2Error(!updateAddressLine2);
    setShowUpdateCityError(!updateCity);
    setShowUpdatePincodeError(!updatePincode || !isNumeric(updatePincode));
    setShowUpdateStateError(!updateState);
    setShowUpdateBankNameError(!updateBankName);
    setShowUpdateBankBranchError(!updateBankBranch);
    setShowUpdateBankAccountNumberError(
      !updateBankAccountNumber || !isNumeric(updateBankAccountNumber),
    );
    setShowUpdateIfscCodeError(
      !updateIfscCode || !validateIfsc(updateIfscCode),
    );
    setShowUpdateEstCertificateError(!updateEstCertificate);
    setShowUpdateServiceTaxError(!updateServiceTax);
    setShowUpdateVatTaxError(!updateVatTax);
    setShowUpdatePhoneBillError(!updatePhoneBill);
    setShowUpdateKycCompleteError(!updateKycComplete);
    setShowUpdateTaxSetupError(!updateTaxSetup);
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (
      !updateCustomer ||
      !updatePort ||
      !updatePrimarySales ||
      !updateSecondarySales ||
      !updateCustomerType ||
      !updateSubType ||
      !updateCountry ||
      !updateAddressLine1 ||
      !updateAddressLine2 ||
      !updateCity ||
      !updatePincode ||
      !isNumeric(updatePincode) ||
      !updateState ||
      !updateBankName ||
      !updateBankBranch ||
      !updateBankAccountNumber ||
      !isNumeric(updateBankAccountNumber) ||
      !updateIfscCode ||
      !validateIfsc(updateIfscCode) ||
      !updateEstCertificate ||
      !updateServiceTax ||
      !updateVatTax ||
      !updatePhoneBill ||
      !updateKycComplete ||
      !updateTaxSetup
    ) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const id = updateId;
    const payload = {
      customer: updateCustomer,
      port: updatePort,
      primary_sales: updatePrimarySales,
      secondary_sales: updateSecondarySales,
      customer_type: updateCustomerType,
      sub_type: updateSubType,
      country: updateCountry,
      address_line_1: updateAddressLine1,
      address_line_2: updateAddressLine2,
      city: updateCity,
      pincode: updatePincode,
      state: updateState,
      iec_number: updateIecNumber,
      cha_license_number: updateChaLicenseNumber,
      mto_license_number: updateMtoLicenseNumber,
      pan_number: updatePanNumber,
      service_tax_number: updateServiceTaxNumber,
      var_tax_number: updateVarTax,
      tan_number: updateTanNumber,
      website: updateWebsite,
      gst_category: updateGstCategory,
      gstin: updateGstin,
      bank_name: updateBankName,
      bank_branch: updateBankBranch,
      bank_account_number: updateBankAccountNumber,
      ifsc_code: updateIfscCode,
      est_certificate: updateEstCertificate,
      service_tax: updateServiceTax,
      vat_tax: updateVatTax,
      phone_bill: updatePhoneBill,
      kyc_complete: updateKycComplete,
      tax_setup: updateTaxSetup,
      others: updateOthers,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/customerbranch/" +
          id +
          "/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Customer Branch updated Successfully");
        getCustomerBranch();
      }
    } catch (err) {
      toast.error("Error updating customer branch! Try again.");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Contacts ==========
  const addCustomerContact = async (e) => {
    e.preventDefault();

    setShowContactNameError(!contactName);
    setShowContactResponsibilityError(!contactResponsibility);
    setShowContactEmailError(!contactEmail || !validateEmail(contactEmail));
    setShowContactMobileError(!contactMobile || !validateMobile(contactMobile));
    const contactErrors = buildContactErrorMessages();
    setContactValidationErrorArray(contactErrors);

    if (
      !contactName ||
      !contactResponsibility ||
      !contactEmail ||
      !contactMobile ||
      !validateEmail(contactEmail) ||
      !validateMobile(contactMobile)
    ) {
      setShowContactValidationError(true);
      return;
    }
    setShowContactValidationError(false);

    setShowAddCustomerContactLoader(true);
    const id = updateId;
    const payload = {
      id: id,
      name: contactName,
      responsibility: contactResponsibility,
      email: contactEmail,
      mobile: contactMobile,
      telephone: contactTelephone,
      fax: contactFax,
      is_default: contactDefault,
      status: contactStatus,
    };
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/customerbranch/addnewcontact/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Contact Added Successfully");
        setCustomerContacts(response?.data?.contacts);
      }
      setContactName("");
      setContactResponsibility("");
      setContactEmail("");
      setContactMobile("");
      setContactTelephone("");
      setContactFax("");
      setContactDefault("");
      setContactStatus("");
    } catch (err) {
      toast.error("Error adding contact! Try again.");
    } finally {
      setShowAddCustomerContactLoader(false);
    }
  };

  const setUpdateContactDetails = (row) => {
    setShowUpdateContactForm(true);
    setUpdateContactSerialNumber(row.serial_number);
    setUpdateContactName(row.name);
    setUpdateContactResponsibility(row.responsibility);
    setUpdateContactEmail(row.email);
    setUpdateContactMobile(row.mobile);
    setUpdateContactTelephone(row.telephone);
    setUpdateContactFax(row.fax);
    setUpdateContactStatus(row.status);
    setUpdateContactDefault(row.is_default);
  };

  const setDeleteContactDetails = (row) => {
    setDeleteCustomerContactModal(true);
    setUpdateContactSerialNumber(row.serial_number);
    setUpdateContactName(row.name);
  };

  const updateCustomerContact = async (e) => {
    e.preventDefault();

    setShowUpdateContactNameError(!updateContactName);
    setShowUpdateContactResponsibilityError(!updateContactResponsibility);
    setShowUpdateContactEmailError(
      !updateContactEmail || !validateEmail(updateContactEmail),
    );
    setShowUpdateContactMobileError(
      !updateContactMobile || !validateMobile(updateContactMobile),
    );
    const updateContactErrors = buildUpdateContactErrorMessages();
    setUpdateContactValidationErrorArray(updateContactErrors);

    if (
      !updateContactName ||
      !updateContactResponsibility ||
      !updateContactEmail ||
      !updateContactMobile ||
      !validateEmail(updateContactEmail) ||
      !validateMobile(updateContactMobile)
    ) {
      setShowUpdateContactValidationError(true);
      return;
    }
    setShowUpdateContactValidationError(false);

    setShowUpdateCustomerContactLoader(true);
    const id = updateId;
    const payload = {
      id: id,
      serial_number: updateContactSerialNumber,
      name: updateContactName,
      responsibility: updateContactResponsibility,
      email: updateContactEmail,
      mobile: updateContactMobile,
      telephone: updateContactTelephone,
      fax: updateContactFax,
      is_default: updateContactDefault,
      status: updateContactStatus,
    };
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/customer/updatecontact/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Contact Updated Successfully");
        setCustomerContacts(response?.data?.contacts);
      }
      setUpdateContactName("");
      setUpdateContactResponsibility("");
      setUpdateContactEmail("");
      setUpdateContactMobile("");
      setUpdateContactTelephone("");
      setUpdateContactFax("");
      setUpdateContactDefault("");
      setUpdateContactStatus("");
    } catch (err) {
      toast.error("Error updating contact! Try again.");
    } finally {
      setShowUpdateCustomerContactLoader(false);
    }
  };

  const deleteCustomerContact = async (e) => {
    e.preventDefault();
    setShowDeleteCustomerContactLoader(true);
    const id = updateId;
    const payload = { id: id, serial_number: updateContactSerialNumber };
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/customer/deletecontact/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Contact Deleted Successfully");
        setCustomerContacts(response?.data?.contacts);
      }
      setUpdateContactName("");
      setUpdateContactResponsibility("");
      setUpdateContactEmail("");
      setUpdateContactMobile("");
      setUpdateContactTelephone("");
      setUpdateContactFax("");
      setUpdateContactDefault("");
      setUpdateContactStatus("");
    } catch (err) {
      toast.error("Error deleting contact! Try again.");
    } finally {
      setShowDeleteCustomerContactLoader(false);
      setDeleteCustomerContactModal(false);
    }
  };

  // ========== Uploads ==========
  const handleUploadsFileChange = (files) => {
    const fileArray = Array.from(files);
    setUploadFileNames(fileArray.map((file) => file?.name));
  };

  const addCustomerUploads = async (e) => {
    e.preventDefault();
    setShowUploadFilesLoader(true);
    const id = updateId;
    const payload = { id: id, upload: uploadFiles };
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/customer/customeruploads/",
        payload,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (response.status === 200) {
        toast.success("Files Uploaded Successfully");
        addUploadsform.current.uploads.value = [];
        setCustomerUploads(response.data.upload_urls);
      }
    } catch (err) {
      toast.error("Error uploading files! Try again.");
    } finally {
      setShowUploadFilesLoader(false);
    }
  };

  const setDeleteUploadDetails = (row) => {
    setDeleteCustomerUploadModal(true);
    setUploadFilesSerialNumber(row.serial_number);
    setDeleteUploadFileName(row.filename);
  };

  const deleteCustomerUploads = async (e) => {
    e.preventDefault();
    setShowDeleteUploadFilesLoader(true);
    const id = updateId;
    const payload = { id: id, serial_number: uploadFilesSerialNumber };
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/customer/deletecustomeruploads/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("File Deleted Successfully");
        setCustomerUploads(response.data.upload_urls);
      }
    } catch (err) {
      toast.error("Error deleting file! Try again.");
    } finally {
      setShowDeleteUploadFilesLoader(false);
      setDeleteCustomerUploadModal(false);
    }
  };

  // ========== Sales Uploads ==========
  const handleSalesUploadsFileChange = (files) => {
    const fileArray = Array.from(files);
    setSalesUploadFileNames(fileArray.map((file) => file?.name));
  };

  const addCustomerSalesUploads = async (e) => {
    e.preventDefault();
    setShowSalesUploadFilesLoader(true);
    const id = updateId;
    const payload = { id: id, upload: salesUploadFiles };
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/customer/customersalesuploads/",
        payload,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (response.status === 200) {
        toast.success("Files Uploaded Successfully");
        addSalesUploadsform.current.sales_uploads.value = [];
        setCustomerSalesUploads(response.data.sales_upload_urls);
      }
    } catch (err) {
      toast.error("Error uploading files! Try again.");
    } finally {
      setShowSalesUploadFilesLoader(false);
    }
  };

  const setDeleteSalesUploadDetails = (row) => {
    setDeleteCustomerSalesUploadModal(true);
    setSalesUploadFilesSerialNumber(row.serial_number);
    setDeleteSalesUploadFileName(row.filename);
  };

  const deleteCustomerSalesUploads = async (e) => {
    e.preventDefault();
    setShowDeleteSalesUploadFilesLoader(true);
    const id = updateId;
    const payload = { id: id, serial_number: salesUploadFilesSerialNumber };
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/customer/deletecustomersalesuploads/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("File Deleted Successfully");
        setCustomerSalesUploads(response.data.sales_upload_urls);
      }
    } catch (err) {
      toast.error("Error deleting file! Try again.");
    } finally {
      setShowDeleteSalesUploadFilesLoader(false);
      setDeleteCustomerSalesUploadModal(false);
    }
  };

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  const customComponents = {
    DropdownIndicator: () => null,
    IndicatorSeparator: () => null,
  };

  // ========== Table columns ==========
  const columns = [
    {
      name: "Customer",
      selector: (row) => row.customer_data?.name,
      sortable: true,
    },
    {
      name: "Port",
      selector: (row) => row.port_data?.name,
      sortable: true,
    },
    {
      name: "Category",
      selector: (row) => (
        <div className="mt-2">
          <span>
            <b>Type:</b> {row.customer_type}
          </span>
          <br />
          <span>
            <b>Subtype:</b> {row.sub_type}
          </span>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Sales",
      selector: (row) => (
        <div className="mt-2">
          <span>{row.primary_sales}</span>
          <br />
          <span>{row.secondary_sales}</span>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Country",
      center: true,
      selector: (row) => (
        <div className="text-center">
          <img
            src={row.country_data?.image_url}
            height={20}
            className="mb-1"
            alt=""
          />
          <br />
          <span>{row.country_data?.long_name}</span>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:customer:update") ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              data-bs-toggle="offcanvas"
              data-bs-target="#updateSection"
              onClick={() => handleSetUpdateData(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}
          {currentUserRolePermissionData?.includes("master:customer:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const contactcolumns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    {
      name: "Responsibility",
      selector: (row) => row.responsibility.replaceAll("_", " "),
      sortable: true,
    },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Mobile Number", selector: (row) => row.mobile, sortable: true },
    {
      name: "Telephone Number",
      selector: (row) => row.telephone,
      sortable: true,
    },
    { name: "Fax Number", selector: (row) => row.fax, sortable: true },
    { name: "Default", selector: (row) => row.is_default, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:customer:update") ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => setUpdateContactDetails(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}
          {currentUserRolePermissionData?.includes("master:customer:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => setDeleteContactDetails(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const uploadcolumns = [
    { name: "File Name", selector: (row) => row.filename, sortable: true },
    {
      name: "Url",
      selector: (row) => (
        <a
          href={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
          target="_blank"
          rel="noreferrer"
        >
          {`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
        </a>
      ),
      sortable: true,
    },
    {
      name: "Preview",
      selector: (row) => (
        <img
          className="img img-thumbnail"
          src={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
          height={40}
          width={40}
          alt=""
        />
      ),
      sortable: true,
    },
    { name: "File Type", selector: (row) => row.filetype, sortable: true },
    {
      name: "File Size",
      selector: (row) => row.filesize + " " + row.fileunit,
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:customer:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => setDeleteUploadDetails(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const salesUploadcolumns = [
    { name: "File Name", selector: (row) => row.filename, sortable: true },
    {
      name: "Url",
      selector: (row) => (
        <a
          href={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
          target="_blank"
          rel="noreferrer"
        >
          {`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
        </a>
      ),
      sortable: true,
    },
    { name: "File Type", selector: (row) => row.filetype, sortable: true },
    {
      name: "File Size",
      selector: (row) => row.filesize + " " + row.fileunit,
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:customer:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => setDeleteSalesUploadDetails(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const usercolumns = [
    {
      name: "Profile",
      width: "100px",
      selector: (row) => (
        <div className="text-center">
          {row.picture != null ? (
            <img
              src={row.picture}
              className="img img-thumbnail"
              style={{ height: 50, width: 50 }}
              alt=""
            />
          ) : (
            <img
              src={PlaceholderPicture}
              className="img img-thumbnail border"
              height={50}
              width={50}
              alt=""
            />
          )}
        </div>
      ),
      sortable: true,
    },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Username", selector: (row) => row.username, sortable: true },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Contact", selector: (row) => row.mobile, sortable: true },
    { name: "Is Employee", selector: (row) => row.is_employee, sortable: true },
  ];

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="CustomerBranchMaster"
        activeSubMenuLevel1=""
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Customer Branch Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes(
                "master:customer:add",
              ) ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#addSection"
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Branch</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      {/* -------------------- Delete Modal -------------------- */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-4"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* -------------------- Update Canvas -------------------- */}
      <div
        className={
          canvasFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        id="updateSection"
        data-bs-scroll="true"
        tabIndex="-1"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Update Record
              </h4>
              {[
                {
                  label: "Details",
                  show: showCustomerDetails,
                  onClick: () => {
                    setShowCustomerDetails(true);
                    setShowCustomerContacts(false);
                    setShowCustomerUploads(false);
                    setShowCustomerSalesUploads(false);
                    setShowCustomerUsers(false);
                  },
                },
                {
                  label: "Contacts",
                  show: showCustomerContacts,
                  onClick: () => {
                    setShowCustomerDetails(false);
                    setShowCustomerContacts(true);
                    setShowCustomerUploads(false);
                    setShowCustomerSalesUploads(false);
                    setShowCustomerUsers(false);
                  },
                },
                {
                  label: "Uploads",
                  show: showCustomerUploads,
                  onClick: () => {
                    setShowCustomerDetails(false);
                    setShowCustomerContacts(false);
                    setShowCustomerUploads(true);
                    setShowCustomerSalesUploads(false);
                    setShowCustomerUsers(false);
                  },
                },
                {
                  label: "Sales Uploads",
                  show: showCustomerSalesUploads,
                  onClick: () => {
                    setShowCustomerDetails(false);
                    setShowCustomerContacts(false);
                    setShowCustomerUploads(false);
                    setShowCustomerSalesUploads(true);
                    setShowCustomerUsers(false);
                  },
                },
                {
                  label: "Users",
                  show: showCustomerUsers,
                  onClick: () => {
                    setShowCustomerDetails(false);
                    setShowCustomerContacts(false);
                    setShowCustomerUploads(false);
                    setShowCustomerSalesUploads(false);
                    setShowCustomerUsers(true);
                  },
                },
              ].map((tab) => (
                <Button
                  key={tab.label}
                  className={`${tab.show ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                  style={{
                    marginRight: 10,
                    width: tab.label === "Sales Uploads" ? 140 : 120,
                  }}
                  onClick={tab.onClick}
                >
                  {tab.label}
                </Button>
              ))}
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={() => {
                  setShowUpdateCanvas(false);
                  resetUpdateErrors();
                }}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          {/* Details Tab */}
          <div style={{ display: showCustomerDetails ? "block" : "none" }}>
            <form onSubmit={(e) => updateCustomerDetails(e)}>
              <div className="row">
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_customer">
                    Customer: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateCustomerError ? " Customer is required" : ""}
                    </span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    id="update_customer"
                    name="update_customer"
                    value={updateCustomer}
                    onChange={(e) => {
                      setUpdateCustomer(e.target.value);
                      setShowUpdateCustomerError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdateCustomerError(!e.target.value)}
                  >
                    <option value="">Select Customer</option>
                    {customerList.map((customer) => (
                      <option key={customer.value} value={customer.value}>
                        {customer.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_country">
                    Country: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateCountryError ? " Country required" : ""}
                    </span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    id="update_country"
                    name="update_country"
                    value={updateCountry}
                    onChange={(e) => {
                      setUpdateCountry(e.target.value);
                      setShowUpdateCountryError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdateCountryError(!e.target.value)}
                  >
                    <option value="">Select Country</option>
                    {countryList.map((country) => (
                      <option key={country.value} value={country.value}>
                        {country.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_primary_sales">
                    Primary Sales: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdatePrimarySalesError
                        ? " Primary sales required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_primary_sales"
                    name="update_primary_sales"
                    placeholder="Enter Primary Sales Name"
                    value={updatePrimarySales}
                    onChange={(e) => {
                      setUpdatePrimarySales(e.target.value);
                      setShowUpdatePrimarySalesError(!e.target.value);
                    }}
                    onBlur={(e) =>
                      setShowUpdatePrimarySalesError(!e.target.value)
                    }
                  />
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_secondary_sales">
                    Secondary Sales: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateSecondarySalesError
                        ? " Secondary sales required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_secondary_sales"
                    name="update_secondary_sales"
                    placeholder="Enter Secondary Sales Name"
                    value={updateSecondarySales}
                    onChange={(e) => {
                      setUpdateSecondarySales(e.target.value);
                      setShowUpdateSecondarySalesError(!e.target.value);
                    }}
                    onBlur={(e) =>
                      setShowUpdateSecondarySalesError(!e.target.value)
                    }
                  />
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_customer_type">
                    Customer Type: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateTypeError ? " Customer Type required" : ""}
                    </span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    id="update_customer_type"
                    name="update_customer_type"
                    value={updateCustomerType}
                    onChange={(e) => {
                      setUpdateCustomerType(e.target.value);
                      setShowUpdateTypeError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdateTypeError(!e.target.value)}
                  >
                    <option value="">Select Type</option>
                    <option value="COMPANY">COMPANY</option>
                    <option value="INDIVIDUAL">INDIVIDUAL</option>
                  </select>
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_sub_type">
                    Sub Type: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateSubtypeError ? " Sub Type required" : ""}
                    </span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    id="update_sub_type"
                    name="update_sub_type"
                    value={updateSubType}
                    onChange={(e) => {
                      setUpdateSubType(e.target.value);
                      setShowUpdateSubtypeError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdateSubtypeError(!e.target.value)}
                  >
                    <option value="">Select Sub Type</option>
                    {[
                      "SHIPPER",
                      "CONSIGNEE",
                      "NOTIFY",
                      "PARTY",
                      "NVOCC",
                      "FORWAEDER",
                      "CHA",
                      "INVESTOR",
                      "SURVEYOR",
                      "OTHERS",
                    ].map((v) => (
                      <option key={v} value={v}>
                        {v}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_port">
                    Port: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdatePortError ? " Port is required" : ""}
                    </span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    id="update_port"
                    name="update_port"
                    value={updatePort}
                    onChange={(e) => {
                      setUpdatePort(e.target.value);
                      setShowUpdatePortError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdatePortError(!e.target.value)}
                  >
                    <option value="">Select Port</option>
                    {portList.map((port) => (
                      <option key={port.id} value={port.id}>
                        {port.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_address_line_1">
                    Address Line 1: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateAddressLine1Error ? " Address required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_address_line_1"
                    name="update_address_line_1"
                    placeholder="Enter Address Line 1"
                    value={updateAddressLine1}
                    onChange={(e) => {
                      setUpdateAddressLine1(e.target.value);
                      setShowUpdateAddressLine1Error(!e.target.value);
                    }}
                    onBlur={(e) =>
                      setShowUpdateAddressLine1Error(!e.target.value)
                    }
                  />
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_address_line_2">
                    Address Line 2: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateAddressLine2Error ? " Address required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_address_line_2"
                    name="update_address_line_2"
                    placeholder="Enter Address Line 2"
                    value={updateAddressLine2}
                    onChange={(e) => {
                      setUpdateAddressLine2(e.target.value);
                      setShowUpdateAddressLine2Error(!e.target.value);
                    }}
                    onBlur={(e) =>
                      setShowUpdateAddressLine2Error(!e.target.value)
                    }
                  />
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_city">
                    City: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateCityError ? " City required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_city"
                    name="update_city"
                    placeholder="Enter City"
                    value={updateCity}
                    onChange={(e) => {
                      setUpdateCity(e.target.value);
                      setShowUpdateCityError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdateCityError(!e.target.value)}
                  />
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_pincode">
                    Pincode: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdatePincodeError
                        ? updatePincode
                          ? " Must contain only digits"
                          : " Pincode required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_pincode"
                    name="update_pincode"
                    placeholder="Enter Pincode"
                    value={updatePincode}
                    onChange={(e) => {
                      setUpdatePincode(e.target.value);
                      setShowUpdatePincodeError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      setShowUpdatePincodeError(!val || !isNumeric(val));
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  />
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_state">
                    State: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateStateError ? " State required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_state"
                    name="update_state"
                    placeholder="Enter State"
                    value={updateState}
                    onChange={(e) => {
                      setUpdateState(e.target.value);
                      setShowUpdateStateError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdateStateError(!e.target.value)}
                  />
                </div>

                {updateCountryName === "India" && (
                  <>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_iec_number">
                        IEC Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateIecNumberError
                            ? " IEC number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_iec_number"
                        name="update_iec_number"
                        placeholder="Enter IEC Number"
                        value={updateIecNumber}
                        onChange={(e) => setUpdateIecNumber(e.target.value)}
                        onBlur={(e) =>
                          setShowUpdateIecNumberError(!e.target.value)
                        }
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_cha_license_number">
                        CHA License Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateChaLicenseNumberError
                            ? " CHA license number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_cha_license_number"
                        placeholder="Enter CHA License Number"
                        value={updateChaLicenseNumber}
                        onChange={(e) =>
                          setUpdateChaLicenseNumber(e.target.value)
                        }
                        onBlur={(e) =>
                          setShowUpdateChaLicenseNumberError(!e.target.value)
                        }
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_mto_license_number">
                        MTO License Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateMtoLicenseNumberError
                            ? " MTO license number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_mto_license_number"
                        placeholder="Enter MTO License Number"
                        value={updateMtoLicenseNumber}
                        onChange={(e) =>
                          setUpdateMtoLicenseNumber(e.target.value)
                        }
                        onBlur={(e) =>
                          setShowUpdateMtoLicenseNumberError(!e.target.value)
                        }
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_pan_number">
                        PAN Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdatePanNumberError
                            ? updatePanNumber
                              ? " Invalid format (e.g. ABCDE1234F)"
                              : " PAN Number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_pan_number"
                        placeholder="Enter PAN Number"
                        value={updatePanNumber}
                        onChange={(e) => {
                          setUpdatePanNumber(e.target.value.toUpperCase());
                          setShowUpdatePanNumberError(false);
                          setShowUpdateValidationError(false);
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setShowUpdatePanNumberError(
                            !val || !validatePan(val),
                          );
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages(),
                          );
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_service_tax_number">
                        Service Tax Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateServiceTaxNumberError
                            ? " Service Tax number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_service_tax_number"
                        placeholder="Enter Service Tax Number"
                        value={updateServiceTaxNumber}
                        onChange={(e) =>
                          setUpdateServiceTaxNumber(e.target.value)
                        }
                        onBlur={(e) =>
                          setShowUpdateServiceTaxNumberError(!e.target.value)
                        }
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_var_tax_number">
                        VAR Tax Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateVarTaxNumberError
                            ? " VAR Tax number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_var_tax_number"
                        placeholder="Enter VAR Tax Number"
                        value={updateVarTax}
                        onChange={(e) => setUpdateVarTax(e.target.value)}
                        onBlur={(e) =>
                          setShowUpdateVarTaxNumberError(!e.target.value)
                        }
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_tan_number">
                        TAN Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateTanNumberError
                            ? " TAN number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_tan_number"
                        placeholder="Enter TAN Number"
                        value={updateTanNumber}
                        onChange={(e) => setUpdateTanNumber(e.target.value)}
                        onBlur={(e) =>
                          setShowUpdateTanNumberError(!e.target.value)
                        }
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_website">Website:</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_website"
                        placeholder="Enter Website"
                        value={updateWebsite}
                        onChange={(e) => setUpdateWebsite(e.target.value)}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_gst_category">
                        GST Category: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateGstCategoryError
                            ? " GST category required"
                            : ""}
                        </span>
                      </label>
                      <select
                        className="form-select form-select-sm"
                        id="update_gst_category"
                        value={updateGstCategory}
                        onChange={(e) => {
                          setUpdateGstCategory(e.target.value);
                          setShowUpdateGstCategoryError(!e.target.value);
                        }}
                        onBlur={(e) =>
                          setShowUpdateGstCategoryError(!e.target.value)
                        }
                      >
                        <option value="">Select Category</option>
                        {[
                          "CONSUMER",
                          "DEEMED",
                          "EXPORT",
                          "OVERSEAS",
                          "REGISTERED_REGULAR",
                          "REGISTERED_COMPOSITION",
                          "SEZ",
                          "UNREGISTERED",
                          "UIN_HOLDER",
                          "OTHERS",
                        ].map((v) => (
                          <option key={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_gstin">
                        GSTIN: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateGstinError
                            ? updateGstin
                              ? " Invalid format (e.g. 22ABCDE1234F1Z5)"
                              : " GSTIN required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_gstin"
                        placeholder="Enter GSTIN"
                        value={updateGstin}
                        onChange={(e) => {
                          setUpdateGstin(e.target.value.toUpperCase());
                          setShowUpdateGstinError(false);
                          setShowUpdateValidationError(false);
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setShowUpdateGstinError(!val || !validateGstin(val));
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages(),
                          );
                        }}
                      />
                    </div>
                  </>
                )}

                {updateCountryName === "United States" && (
                  <>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_usa_business_license_number">
                        Business License Number:{" "}
                        <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateUsaBusinessLicenseNumberError
                            ? " Business License number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_usa_business_license_number"
                        placeholder="Enter Business License Number"
                        value={updateUsaBusinessLicenseNumber}
                        onChange={(e) =>
                          setUpdateUsaBusinessLicenseNumber(e.target.value)
                        }
                        onBlur={(e) =>
                          setShowUpdateUsaBusinessLicenseNumberError(
                            !e.target.value,
                          )
                        }
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_usa_ein_number">
                        EIN Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateUsaEinNumberError
                            ? " EIN number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_usa_ein_number"
                        placeholder="Enter EIN Number"
                        value={updateUsaEinNumber}
                        onChange={(e) => setUpdateUsaEinNumber(e.target.value)}
                        onBlur={(e) =>
                          setShowUpdateUsaEinNumberError(!e.target.value)
                        }
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_usa_fmc_license_number">
                        FMC License Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateUsaFmcLicenseNumberError
                            ? " FMC License number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_usa_fmc_license_number"
                        placeholder="Enter FMC License Number"
                        value={updateUsaFmcLicenseNumber}
                        onChange={(e) =>
                          setUpdateUsaFmcLicenseNumber(e.target.value)
                        }
                        onBlur={(e) =>
                          setShowUpdateUsaFmcLicenseNumberError(!e.target.value)
                        }
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="update_usa_scac_code">
                        SCAC Code: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showUpdateUsaScacCodeError
                            ? " SCAC Code required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_usa_scac_code"
                        placeholder="Enter SCAC Code"
                        value={updateUsaScacCode}
                        onChange={(e) => setUpdateUsaScacCode(e.target.value)}
                        onBlur={(e) =>
                          setShowUpdateUsaScacCodeError(!e.target.value)
                        }
                      />
                    </div>
                  </>
                )}

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_bank_name">
                    Bank Name: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateBankNameError ? " Bank name required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_bank_name"
                    placeholder="Enter Bank Name"
                    value={updateBankName}
                    onChange={(e) => {
                      setUpdateBankName(e.target.value);
                      setShowUpdateBankNameError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdateBankNameError(!e.target.value)}
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_bank_branch">
                    Bank Branch: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateBankBranchError ? " Bank branch required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_bank_branch"
                    placeholder="Enter Bank Branch"
                    value={updateBankBranch}
                    onChange={(e) => {
                      setUpdateBankBranch(e.target.value);
                      setShowUpdateBankBranchError(!e.target.value);
                    }}
                    onBlur={(e) =>
                      setShowUpdateBankBranchError(!e.target.value)
                    }
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_bank_account_number">
                    Bank Account Number: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateBankAccountNumberError
                        ? updateBankAccountNumber
                          ? " Must contain only digits"
                          : " Bank account number required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_bank_account_number"
                    placeholder="Enter Bank Account Number"
                    value={updateBankAccountNumber}
                    onChange={(e) => {
                      setUpdateBankAccountNumber(e.target.value);
                      setShowUpdateBankAccountNumberError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      setShowUpdateBankAccountNumberError(
                        !val || !isNumeric(val),
                      );
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_ifsc_code">
                    IFSC Code: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateIfscCodeError
                        ? updateIfscCode
                          ? " Invalid format (e.g. SBIN0001234)"
                          : " IFSC code required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_ifsc_code"
                    placeholder="Enter IFSC Code"
                    value={updateIfscCode}
                    onChange={(e) => {
                      setUpdateIfscCode(e.target.value.toUpperCase());
                      setShowUpdateIfscCodeError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      setShowUpdateIfscCodeError(!val || !validateIfsc(val));
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_est_certificate">
                    EST Certificate: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateEstCertificateError
                        ? " EST certificate required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_est_certificate"
                    placeholder="Enter EST Certificate"
                    value={updateEstCertificate}
                    onChange={(e) => {
                      setUpdateEstCertificate(e.target.value);
                      setShowUpdateEstCertificateError(!e.target.value);
                    }}
                    onBlur={(e) =>
                      setShowUpdateEstCertificateError(!e.target.value)
                    }
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_service_tax">
                    Service Tax: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateServiceTaxError ? " Service tax required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_service_tax"
                    placeholder="Enter Service Tax"
                    value={updateServiceTax}
                    onChange={(e) => {
                      setUpdateServiceTax(e.target.value);
                      setShowUpdateServiceTaxError(!e.target.value);
                    }}
                    onBlur={(e) =>
                      setShowUpdateServiceTaxError(!e.target.value)
                    }
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_vat_tax">
                    VAT Tax: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateVatTaxError ? " VAT tax required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_vat_tax"
                    placeholder="Enter VAT Tax"
                    value={updateVatTax}
                    onChange={(e) => {
                      setUpdateVatTax(e.target.value);
                      setShowUpdateVatTaxError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdateVatTaxError(!e.target.value)}
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_phone_bill">
                    Phone Bill: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdatePhoneBillError ? " Phone bill required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_phone_bill"
                    placeholder="Enter Phone Bill"
                    value={updatePhoneBill}
                    onChange={(e) => {
                      setUpdatePhoneBill(e.target.value);
                      setShowUpdatePhoneBillError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdatePhoneBillError(!e.target.value)}
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_kyc_complete">
                    KYC Complete: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateKycCompleteError
                        ? " KYC completion status required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_kyc_complete"
                    placeholder="Enter KYC Status"
                    value={updateKycComplete}
                    onChange={(e) => {
                      setUpdateKycComplete(e.target.value);
                      setShowUpdateKycCompleteError(!e.target.value);
                    }}
                    onBlur={(e) =>
                      setShowUpdateKycCompleteError(!e.target.value)
                    }
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_tax_setup">
                    Tax Setup: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateTaxSetupError ? " Tax setup required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_tax_setup"
                    placeholder="Enter Tax Setup"
                    value={updateTaxSetup}
                    onChange={(e) => {
                      setUpdateTaxSetup(e.target.value);
                      setShowUpdateTaxSetupError(!e.target.value);
                    }}
                    onBlur={(e) => setShowUpdateTaxSetupError(!e.target.value)}
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_others">Others:</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_others"
                    placeholder="Enter any other details"
                    value={updateOthers}
                    onChange={(e) => setUpdateOthers(e.target.value)}
                  />
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-12" : "col-md-12"}`}
                >
                  <div className="canvas-btn-row">
                    <Button
                      type="button"
                      className="btn btn-inox-green border-0 canvas-button"
                      onClick={(e) => updateCustomerDetails(e)}
                      disabled={hasAnyUpdateError() || showUpdateLoader}
                    >
                      {showUpdateLoader ? (
                        <Spinner
                          className="mx-4"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <>
                          <i className="fa fa-edit"></i>{" "}
                          <span className="mx-2">Update</span>
                        </>
                      )}
                    </Button>

                    {(hasAnyUpdateError() || showUpdateValidationError) && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          className="mx-2"
                          onClick={handleUpdateCheckValidationClick}
                          onMouseLeave={() =>
                            setIsUpdateValidationErrorVisible(false)
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {isUpdateValidationErrorVisible && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {buildUpdateErrorMessages().map(
                                (error, index) => (
                                  <li
                                    key={index}
                                    className="text-left small pb-0"
                                  >
                                    {error}
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>

          {/* Contacts Tab */}
          <div style={{ display: showCustomerContacts ? "block" : "none" }}>
            {!showUpdateContactForm ? (
              <form
                ref={addcontactform}
                onSubmit={(e) => addCustomerContact(e)}
              >
                <div className="row">
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="contact_name">
                      Name: <i className="text-danger">*</i>
                      <span className="text-danger">
                        {showContactNameError ? " Name required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="contact_name"
                      name="contact_name"
                      placeholder="Enter Name"
                      value={contactName}
                      onChange={(e) => {
                        setContactName(e.target.value);
                        setShowContactNameError(false);
                      }}
                      onBlur={(e) => setShowContactNameError(!e.target.value)}
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="contact_responsibility">
                      Responsibility: <i className="text-danger">*</i>
                      <span className="text-danger">
                        {showContactResponsibilityError ? " Required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      id="contact_responsibility"
                      name="contact_responsibility"
                      onChange={(e) => setContactResponsibility(e.target.value)}
                      onBlur={(e) =>
                        setShowContactResponsibilityError(!e.target.value)
                      }
                    >
                      <option value="">Select Category</option>
                      {[
                        "REPAOR_VENDOR",
                        "SURVEYOR",
                        "MANAGER",
                        "OPERATIONS",
                        "SALES",
                        "TRADE",
                        "COMMERCIALS",
                        "CUSTOMER_CARE",
                        "DIRECTOR",
                        "OWNER",
                        "OTHER",
                      ].map((v) => (
                        <option key={v} value={v}>
                          {v.replaceAll("_", " ")}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="contact_email">
                      Email: <i className="text-danger">*</i>
                      <span className="text-danger">
                        {showContactEmailError
                          ? contactEmail
                            ? " Invalid email format"
                            : " Email required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="contact_email"
                      name="contact_email"
                      placeholder="Enter Email"
                      value={contactEmail}
                      onChange={(e) => {
                        setContactEmail(e.target.value);
                        setShowContactEmailError(false);
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowContactEmailError(!val || !validateEmail(val));
                      }}
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="contact_mobile">
                      Mobile Number: <i className="text-danger">*</i>
                      <span className="text-danger">
                        {showContactMobileError
                          ? contactMobile
                            ? " Must be 9–11 digits"
                            : " Mobile required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="contact_mobile"
                      name="contact_mobile"
                      placeholder="Enter Mobile Number"
                      value={contactMobile}
                      onChange={(e) => {
                        setContactMobile(e.target.value);
                        setShowContactMobileError(false);
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowContactMobileError(!val || !validateMobile(val));
                      }}
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="contact_telephone">Telephone:</label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="contact_telephone"
                      name="contact_telephone"
                      placeholder="Enter Telephone Number"
                      value={contactTelephone}
                      onChange={(e) => setContactTelephone(e.target.value)}
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="contact_fax">Fax:</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="contact_fax"
                      name="contact_fax"
                      placeholder="Enter Fax Number"
                      value={contactFax}
                      onChange={(e) => setContactFax(e.target.value)}
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="contact_status">Status:</label>
                    <select
                      className="form-select form-select-sm"
                      id="contact_status"
                      name="contact_status"
                      value={contactStatus}
                      onChange={(e) => setContactStatus(e.target.value)}
                    >
                      <option value="ACTIVE">ACTIVE</option>
                      <option value="INACTIVE">INACTIVE</option>
                    </select>
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="contact_is_default">Is Default:</label>
                    <select
                      className="form-select form-select-sm"
                      id="contact_is_default"
                      name="contact_is_default"
                      value={contactDefault}
                      onChange={(e) => setContactDefault(e.target.value)}
                    >
                      <option value="YES">YES</option>
                      <option value="NO">NO</option>
                    </select>
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <Button
                      className="btn-inox-green border-0 btn-sm w-100 mt-4"
                      onClick={(e) => addCustomerContact(e)}
                      disabled={showAddCustomerContactLoader}
                    >
                      {showAddCustomerContactLoader ? (
                        <Spinner
                          className="mx-3"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Add"
                      )}
                    </Button>
                    {showContactValidationError && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          className="mx-2"
                          onClick={() =>
                            setIsContactValidationErrorVisible(
                              !isContactValidationErrorVisible,
                            )
                          }
                          onMouseLeave={() =>
                            setIsContactValidationErrorVisible(false)
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {isContactValidationErrorVisible && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {contactValidationErrorArray.map(
                                (error, index) => (
                                  <li
                                    key={index}
                                    className="text-left small pb-0"
                                  >
                                    {error}
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            ) : (
              <form onSubmit={(e) => updateCustomerContact(e)}>
                <div className="row">
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="update_contact_name">
                      Name: <i className="text-danger">*</i>
                      <span className="text-danger">
                        {showUpdateContactNameError ? " Name required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="update_contact_name"
                      name="update_contact_name"
                      placeholder="Enter Name"
                      value={updateContactName}
                      onChange={(e) => {
                        setUpdateContactName(e.target.value);
                        setShowUpdateContactNameError(false);
                      }}
                      onBlur={(e) =>
                        setShowUpdateContactNameError(!e.target.value)
                      }
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="update_contact_responsibility">
                      Responsibility: <i className="text-danger">*</i>
                      <span className="text-danger">
                        {showUpdateContactResponsibilityError
                          ? " Required"
                          : ""}
                      </span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      id="update_contact_responsibility"
                      name="contact_responsibility"
                      value={updateContactResponsibility}
                      onChange={(e) =>
                        setUpdateContactResponsibility(e.target.value)
                      }
                      onBlur={(e) =>
                        setShowUpdateContactResponsibilityError(!e.target.value)
                      }
                    >
                      <option value="">Select Category</option>
                      {[
                        "REPAOR_VENDOR",
                        "SURVEYOR",
                        "MANAGER",
                        "OPERATIONS",
                        "SALES",
                        "TRADE",
                        "COMMERCIALS",
                        "CUSTOMER_CARE",
                        "DIRECTOR",
                        "OWNER",
                        "OTHER",
                      ].map((v) => (
                        <option key={v} value={v}>
                          {v.replaceAll("_", " ")}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="update_contact_email">
                      Email: <i className="text-danger">*</i>
                      <span className="text-danger">
                        {showUpdateContactEmailError
                          ? updateContactEmail
                            ? " Invalid email format"
                            : " Email required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="update_contact_email"
                      name="contact_email"
                      placeholder="Enter Email"
                      value={updateContactEmail}
                      onChange={(e) => {
                        setUpdateContactEmail(e.target.value);
                        setShowUpdateContactEmailError(false);
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowUpdateContactEmailError(
                          !val || !validateEmail(val),
                        );
                      }}
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="update_contact_mobile">
                      Mobile Number: <i className="text-danger">*</i>
                      <span className="text-danger">
                        {showUpdateContactMobileError
                          ? updateContactMobile
                            ? " Must be 9–11 digits"
                            : " Mobile required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="update_contact_mobile"
                      name="contact_mobile"
                      placeholder="Enter Mobile Number"
                      value={updateContactMobile}
                      onChange={(e) => {
                        setUpdateContactMobile(e.target.value);
                        setShowUpdateContactMobileError(false);
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowUpdateContactMobileError(
                          !val || !validateMobile(val),
                        );
                      }}
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="update_contact_telephone">Telephone:</label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="update_contact_telephone"
                      name="contact_telephone"
                      placeholder="Enter Telephone Number"
                      value={updateContactTelephone}
                      onChange={(e) =>
                        setUpdateContactTelephone(e.target.value)
                      }
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="update_contact_fax">Fax:</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="update_contact_fax"
                      name="contact_fax"
                      placeholder="Enter Fax Number"
                      value={updateContactFax}
                      onChange={(e) => setUpdateContactFax(e.target.value)}
                    />
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="update_contact_status">Status:</label>
                    <select
                      className="form-select form-select-sm"
                      id="update_contact_status"
                      name="contact_status"
                      value={updateContactStatus}
                      onChange={(e) => setUpdateContactStatus(e.target.value)}
                    >
                      <option value="ACTIVE">ACTIVE</option>
                      <option value="INACTIVE">INACTIVE</option>
                    </select>
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <label htmlFor="update_contact_is_default">
                      Is Default:
                    </label>
                    <select
                      className="form-select form-select-sm"
                      id="update_contact_is_default"
                      name="contact_is_default"
                      value={updateContactDefault}
                      onChange={(e) => setUpdateContactDefault(e.target.value)}
                    >
                      <option value="YES">YES</option>
                      <option value="NO">NO</option>
                    </select>
                  </div>
                  <div
                    className={`form-group ${canvasFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                  >
                    <Button
                      className="btn-inox-green border-0 btn-sm w-100 mt-4"
                      onClick={(e) => updateCustomerContact(e)}
                      disabled={showUpdateCustomerContactLoader}
                    >
                      {showUpdateCustomerContactLoader ? (
                        <Spinner
                          className="mx-3"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Update"
                      )}
                    </Button>
                    {showUpdateContactValidationError && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          className="mx-2"
                          onClick={() =>
                            setIsUpdateContactValidationErrorVisible(
                              !isUpdateContactValidationErrorVisible,
                            )
                          }
                          onMouseLeave={() =>
                            setIsUpdateContactValidationErrorVisible(false)
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {isUpdateContactValidationErrorVisible && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {updateContactValidationErrorArray.map(
                                (error, index) => (
                                  <li
                                    key={index}
                                    className="text-left small pb-0"
                                  >
                                    {error}
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            )}

            {customerContacts.length > 0 ? (
              <DataTable
                columns={contactcolumns}
                data={customerContacts}
                progressPending={contactDataPending}
                progressComponent={
                  <Spinner
                    className="mx-5 text-inox-green table-spinner"
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                  />
                }
                noDataComponent={
                  <p className="text-center table-no-data">No Contacts Found</p>
                }
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
            ) : (
              <p style={{ marginTop: 100 }}>No Contacts Found</p>
            )}

            <Modal
              size="sm"
              show={deleteCustomerContactModal}
              onHide={() => setDeleteCustomerContactModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Delete{" "}
                  <span style={{ fontSize: 10 }}>({updateContactName})</span>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>Do you want to delete this contact?</Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setDeleteCustomerContactModal(false)}
                >
                  Close
                </Button>
                <Button
                  variant="danger"
                  onClick={(e) => deleteCustomerContact(e)}
                >
                  {showDeleteCustomerContactLoader ? (
                    <Spinner
                      className="mx-4"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Delete"
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
          </div>

          {/* Uploads Tab */}
          <div style={{ display: showCustomerUploads ? "block" : "none" }}>
            <form ref={addUploadsform} onSubmit={(e) => addCustomerUploads(e)}>
              <div className="row">
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    id="uploads"
                    name="uploads"
                    accept="image/*, .pdf"
                    onChange={(e) => {
                      handleUploadsFileChange(e.target.files);
                      setUploadFiles(e.target.files);
                    }}
                    multiple
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-10" : "col-md-10"} text-left mb-4`}
                >
                  <Button
                    className="btn-inox-green border-0 btn-sm"
                    onClick={(e) => addCustomerUploads(e)}
                    disabled={uploadFiles?.length < 1}
                  >
                    {showUploadFilesLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <span className="px-1">Upload</span>
                    )}
                  </Button>
                </div>
              </div>
              {uploadFiles?.length > 0 && (
                <div className="row">
                  <div
                    className="col-12"
                    style={{ fontSize: 12, textAlign: "left" }}
                  >
                    Files:{" "}
                    {uploadFileNames.map((name, index) => (
                      <span key={index}>
                        <b>{index + 1}:</b> {name}{" "}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </form>
            {customerUploads?.length > 0 ? (
              <DataTable
                columns={uploadcolumns}
                data={customerUploads}
                progressPending={customerUploadDataPending}
                progressComponent={
                  <Spinner
                    className="mx-5 text-inox-green table-spinner"
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                  />
                }
                noDataComponent={
                  <p className="text-center table-no-data">No Uploads Found</p>
                }
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
            ) : (
              <p style={{ marginTop: 100 }}>No Uploads Found</p>
            )}
            <Modal
              size="sm"
              show={deleteCustomerUploadModal}
              onHide={() => setDeleteCustomerUploadModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Delete{" "}
                  <span style={{ fontSize: 10 }}>({deleteUploadFileName})</span>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>Do you want to delete this file?</Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setDeleteCustomerUploadModal(false)}
                >
                  Close
                </Button>
                <Button
                  variant="danger"
                  onClick={(e) => deleteCustomerUploads(e)}
                >
                  {showDeleteUploadFilesLoader ? (
                    <Spinner
                      className="mx-4"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Delete"
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
          </div>

          {/* Sales Uploads Tab */}
          <div style={{ display: showCustomerSalesUploads ? "block" : "none" }}>
            <form
              ref={addSalesUploadsform}
              onSubmit={(e) => addCustomerSalesUploads(e)}
            >
              <div className="row">
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    id="sales_uploads"
                    name="sales_uploads"
                    accept="application/pdf"
                    onChange={(e) => {
                      handleSalesUploadsFileChange(e.target.files);
                      setSalesUploadFiles(e.target.files);
                    }}
                    multiple
                  />
                </div>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-10" : "col-md-10"} text-left mb-4`}
                >
                  <Button
                    className="btn-inox-green border-0 btn-sm"
                    onClick={(e) => addCustomerSalesUploads(e)}
                    disabled={salesUploadFiles?.length < 1}
                  >
                    {showSalesUploadFilesLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <span className="px-1">Upload</span>
                    )}
                  </Button>
                </div>
              </div>
              {salesUploadFiles?.length > 0 && (
                <div className="row">
                  <div
                    className="col-12"
                    style={{ fontSize: 12, textAlign: "left" }}
                  >
                    Files:{" "}
                    {salesUploadFileNames.map((name, index) => (
                      <span key={index}>
                        <b>{index + 1}:</b> {name}{" "}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </form>
            {customerSalesUploads?.length > 0 ? (
              <DataTable
                columns={salesUploadcolumns}
                data={customerSalesUploads}
                progressPending={customerSalesUploadDataPending}
                progressComponent={
                  <Spinner
                    className="mx-5 text-inox-green table-spinner"
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                  />
                }
                noDataComponent={
                  <p className="text-center table-no-data">No Files Found</p>
                }
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
            ) : (
              <p style={{ marginTop: 100 }}>No Files Found</p>
            )}
            <Modal
              size="sm"
              show={deleteCustomerSalesUploadModal}
              onHide={() => setDeleteCustomerSalesUploadModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Delete{" "}
                  <span style={{ fontSize: 10 }}>
                    ({deleteSalesUploadFileName})
                  </span>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>Do you want to delete this file?</Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setDeleteCustomerSalesUploadModal(false)}
                >
                  Close
                </Button>
                <Button
                  variant="danger"
                  onClick={(e) => deleteCustomerSalesUploads(e)}
                >
                  {showDeleteSalesUploadFilesLoader ? (
                    <Spinner
                      className="mx-4"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Delete"
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
          </div>

          {/* Users Tab */}
          <div style={{ display: showCustomerUsers ? "block" : "none" }}>
            <div
              className="col-12 text-left"
              style={{
                marginTop: -5,
                paddingLeft: 20,
                paddingRight: 30,
                zIndex: 100,
              }}
            >
              <DataTable
                columns={usercolumns}
                data={branchUserList}
                progressPending={dataPending}
                progressComponent={
                  <Spinner
                    className="mx-5 text-inox-green table-spinner"
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                  />
                }
                noDataComponent={
                  <p className="text-center table-no-data">No Data Found</p>
                }
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
            </div>
          </div>
        </div>
      </div>
      {/* -------------------- End Update Canvas -------------------- */}

      {/* -------------------- Add Canvas -------------------- */}
      <div
        className={
          canvasFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        data-bs-scroll="true"
        tabIndex="-1"
        id="addSection"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={resetAddForm}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <div className="row">
            <div className="col-12">
              <Stepper
                activeStep={activeStep}
                styleConfig={{
                  activeBgColor: "#12708C",
                  completedBgColor: "#16576b",
                }}
              >
                {steps.map((label, index) => (
                  <Step
                    label={label}
                    key={index}
                    onClick={() => setActiveStep(index)}
                  />
                ))}
              </Stepper>
            </div>

            <div className="col-12 mt-3">
              <form ref={addform}>
                {/* Step 0: Primary Details */}
                {activeStep === 0 && (
                  <div className="row">
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="customer">
                        Customer: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showCustomerError ? " Customer is required" : ""}
                        </span>
                      </label>
                      <Select
                        options={customerList}
                        id="customer"
                        name="customer"
                        onChange={(e) => {
                          setCurrentSelectedCustomer(e);
                          setCurrentCustomer(e?.value);
                          setShowCustomerError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={() => {
                          setShowCustomerError(!currentCustomer);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        value={currentSelectedCustomer}
                        isMulti={false}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="country">
                        Country: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showCountryError ? " Country required" : ""}
                        </span>
                      </label>
                      <Select
                        options={countryList}
                        id="country"
                        name="country"
                        onChange={(e) => {
                          setCurrentSelectedCountry(e);
                          setCurrentCountry(e?.value);
                          setSelectedCountry(e?.label);
                          setShowCountryError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                          if (e?.value) {
                            setCurrentPort("");
                            getPort(e?.value);
                          }
                        }}
                        onBlur={() => {
                          setShowCountryError(!currentCountry);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        value={currentSelectedCountry}
                        isMulti={false}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="port">
                        Port: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showPortError ? " Port required" : ""}
                        </span>
                      </label>
                      <select
                        className="form-select"
                        id="port"
                        name="port"
                        value={currentPort}
                        onChange={(e) => {
                          setCurrentPort(e.target.value);
                          setShowPortError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowPortError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      >
                        <option value="">Select Port</option>
                        {portList.map((port) => (
                          <option key={port.id} value={port.id}>
                            {port.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="primary_sales">
                        Primary Sales: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showPrimarySalesError ? " Name required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="primary_sales"
                        name="primary_sales"
                        placeholder="Enter Primary Sales Name"
                        value={currentPrimarySales}
                        onChange={(e) => {
                          setCurrentPrimarySales(e.target.value);
                          setShowPrimarySalesError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowPrimarySalesError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="secondary_sales">
                        Secondary Sales: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showSecondarySalesError ? " Name required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="secondary_sales"
                        name="secondary_sales"
                        placeholder="Enter Secondary Sales Name"
                        value={currentSecondarySales}
                        onChange={(e) => {
                          setCurrentSecondarySales(e.target.value);
                          setShowSecondarySalesError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowSecondarySalesError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="customer_type">
                        Customer Type: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showTypeError ? " Type required" : ""}
                        </span>
                      </label>
                      <select
                        className="form-select"
                        id="customer_type"
                        name="customer_type"
                        value={currentCustomerType}
                        onChange={(e) => {
                          setCurrentCustomerType(e.target.value);
                          setShowTypeError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowTypeError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      >
                        <option value="">Select Type</option>
                        <option value="COMPANY">COMPANY</option>
                        <option value="INDIVIDUAL">INDIVIDUAL</option>
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="sub_type">
                        Sub Type: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showSubtypeError ? " Sub Type required" : ""}
                        </span>
                      </label>
                      <select
                        className="form-select"
                        id="sub_type"
                        name="sub_type"
                        value={currentSubType}
                        onChange={(e) => {
                          setCurrentSubType(e.target.value);
                          setShowSubtypeError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowSubtypeError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      >
                        <option value="">Select Sub Type</option>
                        {[
                          "SHIPPER",
                          "CONSIGNEE",
                          "NOTIFY",
                          "PARTY",
                          "NVOCC",
                          "FORWAEDER",
                          "CHA",
                          "INVESTOR",
                          "SURVEYOR",
                          "OTHERS",
                        ].map((v) => (
                          <option key={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="address_line_1">
                        Address Line 1: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showAddressLine1Error ? " Address required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="address_line_1"
                        name="address_line_1"
                        placeholder="Enter Address Line 1"
                        value={currentAddressLine1}
                        onChange={(e) => {
                          setCurrentAddressLine1(e.target.value);
                          setShowAddressLine1Error(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAddressLine1Error(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="address_line_2">
                        Address Line 2: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showAddressLine2Error ? " Address required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="address_line_2"
                        name="address_line_2"
                        placeholder="Enter Address Line 2"
                        value={currentAddressLine2}
                        onChange={(e) => {
                          setCurrentAddressLine2(e.target.value);
                          setShowAddressLine2Error(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAddressLine2Error(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="city">
                        City: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showCityError ? " City required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        name="city"
                        placeholder="Enter City"
                        value={currentCity}
                        onChange={(e) => {
                          setCurrentCity(e.target.value);
                          setShowCityError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowCityError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="pincode">
                        Pincode: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showPincodeError
                            ? currentPincode
                              ? " Must contain only digits"
                              : " Pincode required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="pincode"
                        name="pincode"
                        placeholder="Enter Pincode"
                        value={currentPincode}
                        onChange={(e) => {
                          setCurrentPincode(e.target.value);
                          setShowPincodeError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setShowPincodeError(!val || !isNumeric(val));
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="state">
                        State: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showStateError ? " State required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="state"
                        name="state"
                        placeholder="Enter State"
                        value={currentState}
                        onChange={(e) => {
                          setCurrentState(e.target.value);
                          setShowStateError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowStateError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                  </div>
                )}

                {/* Step 1: Financial Details */}
                {activeStep === 1 && (
                  <div>
                    {selectedCountry === "India" || selectedCountry === "" ? (
                      <div className="row">
                        {/* IEC Number */}
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="iec_number">
                            IEC Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showIecNumberError
                                ? " IEC number required"
                                : showIecNumberExistError
                                  ? " IEC number used"
                                  : ""}
                            </span>
                          </label>
                          <Select
                            id="iec_number"
                            options={eicNumberList.map((o) => ({
                              ...o,
                              isDisabled: true,
                            }))}
                            components={customComponents}
                            inputValue={currentIecNumber}
                            onInputChange={(value, { action }) => {
                              if (
                                action !== "input-blur" &&
                                action !== "menu-close"
                              ) {
                                setCurrentIecNumber(value.toUpperCase());
                                if (
                                  eicNumberList.some(
                                    (n) =>
                                      n.value.toUpperCase() ===
                                      value.toUpperCase(),
                                  )
                                ) {
                                  setShowIecNumberExistError(true);
                                  setCurrentIecNumberExist(true);
                                } else if (value === "") {
                                  setShowIecNumberError(true);
                                } else {
                                  setShowIecNumberExistError(false);
                                  setCurrentIecNumberExist(false);
                                }
                              }
                            }}
                            onBlur={() => {
                              if (!currentIecNumber) {
                                setShowIecNumberError(true);
                              } else if (currentIecNumberExist) {
                                setCurrentIecNumber("");
                                setShowIecNumberExistError(true);
                                setShowIecNumberError(false);
                              } else {
                                setCurrentIecNumberExist(false);
                                setShowIecNumberExistError(false);
                                setShowIecNumberError(false);
                              }
                            }}
                            isClearable={false}
                            menuIsOpen={currentIecNumberExist}
                            onMenuClose={() => setCurrentIecNumberExist(false)}
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                color: state.isDisabled ? "#000" : base.color,
                                backgroundColor: state.isDisabled
                                  ? "#f8f9fa"
                                  : base.backgroundColor,
                                cursor: "default",
                              }),
                            }}
                          />
                        </div>

                        {/* CHA License Number */}
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="cha_license_number">
                            CHA License Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showChaLicenseNumberError
                                ? " CHA License number required"
                                : showChaLicenseNumberExistError
                                  ? " CHA License number used"
                                  : ""}
                            </span>
                          </label>
                          <Select
                            id="cha_license_number"
                            options={chaLicenseNumberList.map((o) => ({
                              ...o,
                              isDisabled: true,
                            }))}
                            components={customComponents}
                            inputValue={currentChaLicenseNumber}
                            onInputChange={(value, { action }) => {
                              if (
                                action !== "input-blur" &&
                                action !== "menu-close"
                              ) {
                                setCurrentChaLicenseNumber(value.toUpperCase());
                                if (
                                  chaLicenseNumberList.some(
                                    (n) =>
                                      n.value.toUpperCase() ===
                                      value.toUpperCase(),
                                  )
                                ) {
                                  setShowChaLicenseNumberExistError(true);
                                  setCurrentChaLicenseNumberExist(true);
                                } else if (value === "") {
                                  setShowChaLicenseNumberError(true);
                                } else {
                                  setShowChaLicenseNumberExistError(false);
                                  setCurrentChaLicenseNumberExist(false);
                                }
                              }
                            }}
                            onBlur={() => {
                              if (!currentChaLicenseNumber) {
                                setShowChaLicenseNumberError(true);
                              } else if (currentChaLicenseNumberExist) {
                                setCurrentChaLicenseNumber("");
                                setShowChaLicenseNumberExistError(true);
                                setShowChaLicenseNumberError(false);
                              } else {
                                setCurrentChaLicenseNumberExist(false);
                                setShowChaLicenseNumberExistError(false);
                                setShowChaLicenseNumberError(false);
                              }
                            }}
                            isClearable={false}
                            menuIsOpen={currentChaLicenseNumberExist}
                            onMenuClose={() =>
                              setCurrentChaLicenseNumberExist(false)
                            }
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                color: state.isDisabled ? "#000" : base.color,
                                backgroundColor: state.isDisabled
                                  ? "#f8f9fa"
                                  : base.backgroundColor,
                                cursor: "default",
                              }),
                            }}
                          />
                        </div>

                        {/* MTO License Number */}
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="mto_license_number">
                            MTO License Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showMtoLicenseNumberError
                                ? " MTO License number required"
                                : showMtoLicenseNumberExistError
                                  ? " MTO License number used"
                                  : ""}
                            </span>
                          </label>
                          <Select
                            id="mto_license_number"
                            options={mtoLicenseNumberList.map((o) => ({
                              ...o,
                              isDisabled: true,
                            }))}
                            components={customComponents}
                            inputValue={currentMtoLicenseNumber}
                            onInputChange={(value, { action }) => {
                              if (
                                action !== "input-blur" &&
                                action !== "menu-close"
                              ) {
                                setCurrentMtoLicenseNumber(value.toUpperCase());
                                if (
                                  mtoLicenseNumberList.some(
                                    (n) =>
                                      n.value.toUpperCase() ===
                                      value.toUpperCase(),
                                  )
                                ) {
                                  setShowMtoLicenseNumberExistError(true);
                                  setCurrentMtoLicenseNumberExist(true);
                                } else if (value === "") {
                                  setShowMtoLicenseNumberError(true);
                                } else {
                                  setShowMtoLicenseNumberExistError(false);
                                  setCurrentMtoLicenseNumberExist(false);
                                }
                              }
                            }}
                            onBlur={() => {
                              if (!currentMtoLicenseNumber) {
                                setShowMtoLicenseNumberError(true);
                              } else if (currentMtoLicenseNumberExist) {
                                setCurrentMtoLicenseNumber("");
                                setShowMtoLicenseNumberExistError(true);
                                setShowMtoLicenseNumberError(false);
                              } else {
                                setCurrentMtoLicenseNumberExist(false);
                                setShowMtoLicenseNumberExistError(false);
                                setShowMtoLicenseNumberError(false);
                              }
                            }}
                            isClearable={false}
                            menuIsOpen={currentMtoLicenseNumberExist}
                            onMenuClose={() =>
                              setCurrentMtoLicenseNumberExist(false)
                            }
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                color: state.isDisabled ? "#000" : base.color,
                                backgroundColor: state.isDisabled
                                  ? "#f8f9fa"
                                  : base.backgroundColor,
                                cursor: "default",
                              }),
                            }}
                          />
                        </div>

                        {/* PAN Number */}
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="pan_number">
                            PAN Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showPanNumberError
                                ? currentPanNumber
                                  ? " Invalid format (e.g. ABCDE1234F)"
                                  : " PAN Number required"
                                : showPanNumberExistError
                                  ? " PAN Number used"
                                  : ""}
                            </span>
                          </label>
                          <Select
                            id="pan_number"
                            options={panNumberList.map((o) => ({
                              ...o,
                              isDisabled: true,
                            }))}
                            components={customComponents}
                            inputValue={currentPanNumber}
                            onInputChange={(value, { action }) => {
                              if (
                                action !== "input-blur" &&
                                action !== "menu-close"
                              ) {
                                setCurrentPanNumber(value.toUpperCase());
                                if (
                                  panNumberList.some(
                                    (n) =>
                                      n.value.toUpperCase() ===
                                      value.toUpperCase(),
                                  )
                                ) {
                                  setShowPanNumberExistError(true);
                                  setCurrentPanNumberExist(true);
                                } else if (value === "") {
                                  setShowPanNumberError(true);
                                } else {
                                  setShowPanNumberExistError(false);
                                  setCurrentPanNumberExist(false);
                                  setShowPanNumberError(false);
                                }
                              }
                            }}
                            onBlur={() => {
                              if (!currentPanNumber) {
                                setShowPanNumberError(true);
                              } else if (currentPanNumberExist) {
                                setCurrentPanNumber("");
                                setShowPanNumberExistError(true);
                                setShowPanNumberError(false);
                              } else if (!validatePan(currentPanNumber)) {
                                setShowPanNumberError(true);
                                setShowPanNumberExistError(false);
                              } else {
                                setCurrentPanNumberExist(false);
                                setShowPanNumberExistError(false);
                                setShowPanNumberError(false);
                              }
                            }}
                            isClearable={false}
                            menuIsOpen={currentPanNumberExist}
                            onMenuClose={() => setCurrentPanNumberExist(false)}
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                color: state.isDisabled ? "#000" : base.color,
                                backgroundColor: state.isDisabled
                                  ? "#f8f9fa"
                                  : base.backgroundColor,
                                cursor: "default",
                              }),
                            }}
                          />
                        </div>

                        {/* Service Tax Number */}
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="service_tax_number">
                            Service Tax Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showServiceTaxNumberError
                                ? " Service Tax number required"
                                : showServiceTaxNumberExistError
                                  ? " Service Tax number used"
                                  : ""}
                            </span>
                          </label>
                          <Select
                            id="service_tax_number"
                            options={serviceTaxNumberList.map((o) => ({
                              ...o,
                              isDisabled: true,
                            }))}
                            components={customComponents}
                            inputValue={currentServiceTaxNumber}
                            onInputChange={(value, { action }) => {
                              if (
                                action !== "input-blur" &&
                                action !== "menu-close"
                              ) {
                                setCurrentServiceTaxNumber(value.toUpperCase());
                                if (
                                  serviceTaxNumberList.some(
                                    (n) =>
                                      n.value.toUpperCase() ===
                                      value.toUpperCase(),
                                  )
                                ) {
                                  setShowServiceTaxNumberExistError(true);
                                  setCurrentServiceTaxNumberExist(true);
                                } else if (value === "") {
                                  setShowServiceTaxNumberError(true);
                                } else {
                                  setShowServiceTaxNumberExistError(false);
                                  setCurrentServiceTaxNumberExist(false);
                                }
                              }
                            }}
                            onBlur={() => {
                              if (!currentServiceTaxNumber) {
                                setShowServiceTaxNumberError(true);
                              } else if (currentServiceTaxNumberExist) {
                                setCurrentServiceTaxNumber("");
                                setShowServiceTaxNumberExistError(true);
                                setShowServiceTaxNumberError(false);
                              } else {
                                setCurrentServiceTaxNumberExist(false);
                                setShowServiceTaxNumberExistError(false);
                                setShowServiceTaxNumberError(false);
                              }
                            }}
                            isClearable={false}
                            menuIsOpen={currentServiceTaxNumberExist}
                            onMenuClose={() =>
                              setCurrentServiceTaxNumberExist(false)
                            }
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                color: state.isDisabled ? "#000" : base.color,
                                backgroundColor: state.isDisabled
                                  ? "#f8f9fa"
                                  : base.backgroundColor,
                                cursor: "default",
                              }),
                            }}
                          />
                        </div>

                        {/* VAR Tax Number */}
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="var_tax_number">
                            VAR Tax Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showVarTaxNumberError
                                ? " VAR Tax number required"
                                : showVarTaxNumberExistError
                                  ? " VAR Tax number used"
                                  : ""}
                            </span>
                          </label>
                          <Select
                            id="var_tax_number"
                            options={varTaxNumberList.map((o) => ({
                              ...o,
                              isDisabled: true,
                            }))}
                            components={customComponents}
                            inputValue={currentVarTaxNumber}
                            onInputChange={(value, { action }) => {
                              if (
                                action !== "input-blur" &&
                                action !== "menu-close"
                              ) {
                                setCurrentVarTaxNumber(value.toUpperCase());
                                if (
                                  varTaxNumberList.some(
                                    (n) =>
                                      n.value.toUpperCase() ===
                                      value.toUpperCase(),
                                  )
                                ) {
                                  setShowVarTaxNumberExistError(true);
                                  setCurrentVarTaxNumberExist(true);
                                } else if (value === "") {
                                  setShowVarTaxNumberError(true);
                                } else {
                                  setShowVarTaxNumberExistError(false);
                                  setCurrentVarTaxNumberExist(false);
                                }
                              }
                            }}
                            onBlur={() => {
                              if (!currentVarTaxNumber) {
                                setShowVarTaxNumberError(true);
                              } else if (currentVarTaxNumberExist) {
                                setCurrentVarTaxNumber("");
                                setShowVarTaxNumberExistError(true);
                                setShowVarTaxNumberError(false);
                              } else {
                                setCurrentVarTaxNumberExist(false);
                                setShowVarTaxNumberExistError(false);
                                setShowVarTaxNumberError(false);
                              }
                            }}
                            isClearable={false}
                            menuIsOpen={currentVarTaxNumberExist}
                            onMenuClose={() =>
                              setCurrentVarTaxNumberExist(false)
                            }
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                color: state.isDisabled ? "#000" : base.color,
                                backgroundColor: state.isDisabled
                                  ? "#f8f9fa"
                                  : base.backgroundColor,
                                cursor: "default",
                              }),
                            }}
                          />
                        </div>

                        {/* TAN Number */}
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="tan_number">
                            TAN Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showTanNumberError
                                ? " TAN number required"
                                : showTanNumberExistError
                                  ? " TAN number used"
                                  : ""}
                            </span>
                          </label>
                          <Select
                            id="tan_number"
                            options={tanNumberList.map((o) => ({
                              ...o,
                              isDisabled: true,
                            }))}
                            components={customComponents}
                            inputValue={currentTanNumber}
                            onInputChange={(value, { action }) => {
                              if (
                                action !== "input-blur" &&
                                action !== "menu-close"
                              ) {
                                setCurrentTanNumber(value.toUpperCase());
                                if (
                                  tanNumberList.some(
                                    (n) =>
                                      n.value.toUpperCase() ===
                                      value.toUpperCase(),
                                  )
                                ) {
                                  setShowTanNumberExistError(true);
                                  setCurrentTanNumberExist(true);
                                } else if (value === "") {
                                  setShowTanNumberError(true);
                                } else {
                                  setShowTanNumberExistError(false);
                                  setCurrentTanNumberExist(false);
                                }
                              }
                            }}
                            onBlur={() => {
                              if (!currentTanNumber) {
                                setShowTanNumberError(true);
                              } else if (currentTanNumberExist) {
                                setCurrentTanNumber("");
                                setShowTanNumberExistError(true);
                                setShowTanNumberError(false);
                              } else {
                                setCurrentTanNumberExist(false);
                                setShowTanNumberExistError(false);
                                setShowTanNumberError(false);
                              }
                            }}
                            isClearable={false}
                            menuIsOpen={currentTanNumberExist}
                            onMenuClose={() => setCurrentTanNumberExist(false)}
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                color: state.isDisabled ? "#000" : base.color,
                                backgroundColor: state.isDisabled
                                  ? "#f8f9fa"
                                  : base.backgroundColor,
                                cursor: "default",
                              }),
                            }}
                          />
                        </div>

                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="website">Website:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="website"
                            name="website"
                            placeholder="Enter Website"
                            onChange={(e) => setCurrentWebsite(e.target.value)}
                            value={currentWebsite}
                          />
                        </div>

                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="gst_category">
                            GST Category: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showGstCategoryError
                                ? " GST category required"
                                : ""}
                            </span>
                          </label>
                          <select
                            className="form-select"
                            id="gst_category"
                            name="gst_category"
                            value={currentGstCategory}
                            onChange={(e) => {
                              setCurrentGstCategory(e.target.value);
                              setShowGstCategoryError(!e.target.value);
                            }}
                            onBlur={(e) =>
                              setShowGstCategoryError(!e.target.value)
                            }
                          >
                            <option value="">Select Category</option>
                            {[
                              "CONSUMER",
                              "DEEMED",
                              "EXPORT",
                              "OVERSEAS",
                              "REGISTERED_REGULAR",
                              "REGISTERED_COMPOSITION",
                              "SEZ",
                              "UNREGISTERED",
                              "UIN_HOLDER",
                              "OTHERS",
                            ].map((v) => (
                              <option key={v} value={v}>
                                {v}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* GSTIN */}
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="gstin">
                            GSTIN: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showGstinError
                                ? currentGstin
                                  ? " Invalid format (e.g. 22ABCDE1234F1Z5)"
                                  : " GSTIN required"
                                : showGstinExistError
                                  ? " GSTIN used"
                                  : ""}
                            </span>
                          </label>
                          <Select
                            id="gstin"
                            options={gstinList.map((o) => ({
                              ...o,
                              isDisabled: true,
                            }))}
                            components={customComponents}
                            inputValue={currentGstin}
                            onInputChange={(value, { action }) => {
                              if (
                                action !== "input-blur" &&
                                action !== "menu-close"
                              ) {
                                setCurrentGstin(value.toUpperCase());
                                if (
                                  gstinList.some(
                                    (n) =>
                                      n.value.toUpperCase() ===
                                      value.toUpperCase(),
                                  )
                                ) {
                                  setShowGstinExistError(true);
                                  setCurrentGstinExist(true);
                                } else if (value === "") {
                                  setShowGstinError(true);
                                } else {
                                  setShowGstinExistError(false);
                                  setCurrentGstinExist(false);
                                  setShowGstinError(false);
                                }
                              }
                            }}
                            onBlur={() => {
                              if (!currentGstin) {
                                setShowGstinError(true);
                              } else if (currentGstinExist) {
                                setCurrentGstin("");
                                setShowGstinExistError(true);
                                setShowGstinError(false);
                              } else if (!validateGstin(currentGstin)) {
                                setShowGstinError(true);
                                setShowGstinExistError(false);
                              } else {
                                setCurrentGstinExist(false);
                                setShowGstinExistError(false);
                                setShowGstinError(false);
                              }
                            }}
                            isClearable={false}
                            menuIsOpen={currentGstinExist}
                            onMenuClose={() => setCurrentGstinExist(false)}
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                color: state.isDisabled ? "#000" : base.color,
                                backgroundColor: state.isDisabled
                                  ? "#f8f9fa"
                                  : base.backgroundColor,
                                cursor: "default",
                              }),
                            }}
                          />
                        </div>
                      </div>
                    ) : selectedCountry === "United States" ? (
                      <div className="row">
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="usa_ein_number">
                            EIN Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUsaEinNumberError
                                ? " EIN number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="usa_ein_number"
                            name="usa_ein_number"
                            placeholder="Enter EIN Number"
                            value={currentUsaEinNumber}
                            onChange={(e) => {
                              setCurrentUsaEinNumber(e.target.value);
                              setShowUsaEinNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUsaEinNumberError(!e.target.value);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="usa_fmc_license_number">
                            FMC License Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUsaFmcLicenseNumberError
                                ? " FMC license number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="usa_fmc_license_number"
                            name="usa_fmc_license_number"
                            placeholder="Enter FMC License Number"
                            value={currentUsaFmcLicenseNumber}
                            onChange={(e) => {
                              setCurrentUsaFmcLicenseNumber(e.target.value);
                              setShowUsaFmcLicenseNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUsaFmcLicenseNumberError(!e.target.value);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="usa_scac_code">
                            SCAC Code: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUsaScacCodeError
                                ? " SCAC code required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="usa_scac_code"
                            name="usa_scac_code"
                            placeholder="Enter SCAC Code"
                            value={currentUsaScacCode}
                            onChange={(e) => {
                              setCurrentUsaScacCode(e.target.value);
                              setShowUsaScacCodeError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUsaScacCodeError(!e.target.value);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="usa_customs_bond">
                            Customs Bond: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUsaCustomsBondError
                                ? " Customs Bond required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="usa_customs_bond"
                            name="usa_customs_bond"
                            onBlur={(e) =>
                              setShowUsaCustomsBondError(!e.target.files)
                            }
                            onChange={(e) =>
                              setCurrentUsaCustomsBond(e.target.files[0])
                            }
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="usa_business_license_number">
                            Business License Number:{" "}
                            <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUsaBusinessLicenseNumberError
                                ? " Business license number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="usa_business_license_number"
                            name="usa_business_license_number"
                            placeholder="Enter Business License Number"
                            value={currentUsaBusinessLicenseNumber}
                            onChange={(e) => {
                              setCurrentUsaBusinessLicenseNumber(
                                e.target.value,
                              );
                              setShowUsaBusinessLicenseNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUsaBusinessLicenseNumberError(
                                !e.target.value,
                              );
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="usa_power_of_attorney">
                            Power of Attorney: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUsaPowerOfAttorneyError
                                ? " Power of Attorney required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="usa_power_of_attorney"
                            name="usa_power_of_attorney"
                            onBlur={(e) =>
                              setShowUsaPowerOfAttorneyError(!e.target.files)
                            }
                            onChange={(e) =>
                              setCurrentUsaPowerOfAttorney(e.target.files[0])
                            }
                          />
                        </div>
                      </div>
                    ) : selectedCountry === "Singapore" ? (
                      <div className="row">
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="singapore_uen_number">
                            UEN Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showSingaporeUENNumberError
                                ? " UEN Number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="singapore_uen_number"
                            placeholder="Enter UEN Number"
                            value={currentSingaporeUENNumber}
                            onChange={(e) => {
                              setCurrentSingaporeUENNumber(e.target.value);
                              setShowSingaporeUENNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowSingaporeUENNumberError(!e.target.value);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="singapore_customs_account_number">
                            Customs Account Number:{" "}
                            <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showSingaporeCustomsAccountNumberError
                                ? " Customs Account number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="singapore_customs_account_number"
                            placeholder="Enter Customs Account Number"
                            value={currentSingaporeCustomsAccountNumber}
                            onChange={(e) => {
                              setCurrentSingaporeCustomsAccountNumber(
                                e.target.value,
                              );
                              setShowSingaporeCustomsAccountNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowSingaporeCustomsAccountNumberError(
                                !e.target.value,
                              );
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="singapore_gst_number">
                            GST Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showSingaporeGSTNumberError
                                ? " GST number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="singapore_gst_number"
                            placeholder="Enter GST Number"
                            value={currentSingaporeGSTNumber}
                            onChange={(e) => {
                              setCurrentSingaporeGSTNumber(e.target.value);
                              setShowSingaporeGSTNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowSingaporeGSTNumberError(!e.target.value);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="singapore_freight_forwarder_permit">
                            Freight Forwarder Permit:{" "}
                            <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showSingaporeFreightForwarderPermitError
                                ? " FTO Filing Certificate required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="singapore_freight_forwarder_permit"
                            onBlur={(e) =>
                              setShowSingaporeFreightForwarderPermitError(
                                !e.target.value,
                              )
                            }
                            onChange={(e) =>
                              setCurrentSingaporeFreightForwarderPermit(
                                e.target.files[0],
                              )
                            }
                          />
                        </div>
                      </div>
                    ) : selectedCountry === "China" ? (
                      <div className="row">
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="china_business_license_number">
                            Business License Number:{" "}
                            <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showChinaBusinessLicenseNumberError
                                ? " Business license number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="china_business_license_number"
                            placeholder="Enter Business License Number"
                            value={currentChinaBusinessLicenseNumber}
                            onChange={(e) => {
                              setCurrentChinaBusinessLicenseNumber(
                                e.target.value,
                              );
                              setShowChinaBusinessLicenseNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowChinaBusinessLicenseNumberError(
                                !e.target.value,
                              );
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="china_customs_registration_number">
                            Customs Registration Number:{" "}
                            <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showChinaCustomsRegistrationNumberError
                                ? " Customs Registration number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="china_customs_registration_number"
                            placeholder="Enter Customs Registration Number"
                            value={currentChinaCustomsRegistrationNumber}
                            onChange={(e) => {
                              setCurrentChinaCustomsRegistrationNumber(
                                e.target.value,
                              );
                              setShowChinaCustomsRegistrationNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowChinaCustomsRegistrationNumberError(
                                !e.target.value,
                              );
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="china_import_export_number">
                            Import/Export License Number:{" "}
                            <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showChinaImportExportLicenseNumberError
                                ? " Import/Export License number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="china_import_export_number"
                            placeholder="Enter Import/Export License Number"
                            value={currentChinaImportExportLicenseNumber}
                            onChange={(e) => {
                              setCurrentChinaImportExportLicenseNumber(
                                e.target.value,
                              );
                              setShowChinaImportExportLicenseNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowChinaImportExportLicenseNumberError(
                                !e.target.value,
                              );
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="china_fto_filing_certificate">
                            FTO Filing Certificate:{" "}
                            <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showFtoFilingCertificateError
                                ? " FTO Filing Certificate required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="china_fto_filing_certificate"
                            onBlur={(e) =>
                              setShowFtoFilingCertificateError(!e.target.value)
                            }
                            onChange={(e) =>
                              setChinaCurrentFtoFilingCertificate(
                                e.target.files[0],
                              )
                            }
                          />
                        </div>
                      </div>
                    ) : selectedCountry === "United Arab Emirates" ? (
                      <div className="row">
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="uae_trade_license_number">
                            Trade License Number:{" "}
                            <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUAETradeLicenseNumberError
                                ? " Trade License number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="uae_trade_license_number"
                            placeholder="Enter Trade License Number"
                            value={currentUAETradeLicenseNumber}
                            onChange={(e) => {
                              setCurrentUAETradeLicenseNumber(e.target.value);
                              setShowUAETradeLicenseNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUAETradeLicenseNumberError(
                                !e.target.value,
                              );
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="uae_import_export_code">
                            Import/Export Code: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUAEImportExportCodeError
                                ? " Import/Export code required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="uae_import_export_code"
                            placeholder="Enter Import/Export Code"
                            value={currentUAEImportExportCode}
                            onChange={(e) => {
                              setCurrentUAEImportExportCode(e.target.value);
                              setShowUAEImportExportCodeError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUAEImportExportCodeError(!e.target.value);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="uae_trn_number">
                            TRN Number: <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUAETRNNumberError
                                ? " TRN Number required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="uae_trn_number"
                            placeholder="Enter TRN Number"
                            value={currentUAETRNNumber}
                            onChange={(e) => {
                              setCurrentUAETRNNumber(e.target.value);
                              setShowUAETRNNumberError(false);
                              setShowAddValidationError(false);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUAETRNNumberError(!e.target.value);
                              setAddValidationErrorArray(
                                buildAddErrorMessages(),
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="uae_chamber_of_commerce_certificate">
                            Chamber of Commerce Certificate:{" "}
                            <i className="text-danger">*</i>
                            <span className="text-danger">
                              {showUAEChamberOfCommerceCertificateError
                                ? " Certificate required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="uae_chamber_of_commerce_certificate"
                            onBlur={(e) =>
                              setShowUAEChamberOfCommerceCertificateError(
                                !e.target.value,
                              )
                            }
                            onChange={(e) =>
                              setCurrentUAEChamberOfCommerceCertificate(
                                e.target.files[0],
                              )
                            }
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}

                {/* Step 2: Banking and Accounts */}
                {activeStep === 2 && (
                  <div className="row">
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="bank_name">
                        Bank Name: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showBankNameError ? " Bank name required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="bank_name"
                        name="bank_name"
                        placeholder="Enter Bank Name"
                        value={currentBankName}
                        onChange={(e) => {
                          setCurrentBankName(e.target.value);
                          setShowBankNameError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowBankNameError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="bank_branch">
                        Bank Branch: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showBankBranchError ? " Bank branch required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="bank_branch"
                        name="bank_branch"
                        placeholder="Enter Bank Branch"
                        value={currentBankBranch}
                        onChange={(e) => {
                          setCurrentBankBranch(e.target.value);
                          setShowBankBranchError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowBankBranchError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="bank_account_number">
                        Bank Account Number: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showBankAccountNumberError
                            ? currentBankAccountNumber
                              ? " Must contain only digits"
                              : " Bank account number required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="bank_account_number"
                        name="bank_account_number"
                        placeholder="Enter Bank Account Number"
                        value={currentBankAccountNumber}
                        onChange={(e) => {
                          setCurrentBankAccountNumber(e.target.value);
                          setShowBankAccountNumberError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setShowBankAccountNumberError(
                            !val || !isNumeric(val),
                          );
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="ifsc_code">
                        IFSC Code: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showIfscCodeError
                            ? currentIfscCode
                              ? " Invalid format (e.g. SBIN0001234)"
                              : " IFSC code required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="ifsc_code"
                        name="ifsc_code"
                        placeholder="Enter IFSC Code"
                        value={currentIfscCode}
                        onChange={(e) => {
                          setCurrentIfscCode(e.target.value.toUpperCase());
                          setShowIfscCodeError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setShowIfscCodeError(!val || !validateIfsc(val));
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="est_certificate">
                        EST Certificate: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showEstCertificateError
                            ? " EST certificate required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="est_certificate"
                        name="est_certificate"
                        placeholder="Enter EST Certificate"
                        value={currentEstCertificate}
                        onChange={(e) => {
                          setCurrentEstCertificate(e.target.value);
                          setShowEstCertificateError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowEstCertificateError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="service_tax">
                        Service Tax: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showServiceTaxError ? " Service tax required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="service_tax"
                        name="service_tax"
                        placeholder="Enter Service Tax"
                        value={currentServiceTax}
                        onChange={(e) => {
                          setCurrentServiceTax(e.target.value);
                          setShowServiceTaxError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowServiceTaxError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="vat_tax">
                        VAT Tax: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showVatTaxError ? " VAT tax required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="vat_tax"
                        name="vat_tax"
                        placeholder="Enter VAT Tax"
                        value={currentVatTax}
                        onChange={(e) => {
                          setCurrentVatTax(e.target.value);
                          setShowVatTaxError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowVatTaxError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="phone_bill">
                        Phone Bill: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showPhoneBillError ? " Phone bill required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="phone_bill"
                        name="phone_bill"
                        placeholder="Enter Phone Bill"
                        value={currentPhoneBill}
                        onChange={(e) => {
                          setCurrentPhoneBill(e.target.value);
                          setShowPhoneBillError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowPhoneBillError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="kyc_complete">
                        KYC Complete: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showKycCompleteError
                            ? " KYC completion status required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="kyc_complete"
                        name="kyc_complete"
                        placeholder="Enter KYC Status"
                        value={currentKycComplete}
                        onChange={(e) => {
                          setCurrentKycComplete(e.target.value);
                          setShowKycCompleteError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowKycCompleteError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="tax_setup">
                        Tax Setup: <i className="text-danger">*</i>
                        <span className="text-danger">
                          {showTaxSetupError ? " Tax setup required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="tax_setup"
                        name="tax_setup"
                        placeholder="Enter Tax Setup"
                        value={currentTaxSetup}
                        onChange={(e) => {
                          setCurrentTaxSetup(e.target.value);
                          setShowTaxSetupError(false);
                          setShowAddValidationError(false);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowTaxSetupError(!e.target.value);
                          setAddValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label htmlFor="others">Others:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="others"
                        name="others"
                        placeholder="Enter any other details"
                        onChange={(e) => setCurrentOthers(e.target.value)}
                        value={currentOthers}
                      />
                    </div>
                  </div>
                )}
              </form>

              <div
                className={`form-group ${canvasFullScreen ? "col-md-12" : "col-md-12"} mt-3`}
              >
                {" "}
                <div className="canvas-btn-row">
                  <span
                    className="btn btn-inox-green border-0"
                    style={{ width: 200, marginRight: 10 }}
                    onClick={() =>
                      setActiveStep((prev) => Math.max(prev - 1, 0))
                    }
                    disabled={activeStep === 0}
                  >
                    Back
                  </span>

                  {activeStep === 2 ? (
                    <>
                      <Button
                        type="button"
                        className="btn btn-inox-green border-0"
                        style={{ width: 200 }}
                        onClick={(e) => addNewCustomer(e)}
                        disabled={hasAnyAddError() || showAddLoader}
                      >
                        {showAddLoader ? (
                          <Spinner
                            className="mx-4"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <>
                            <i className="fa fa-plus"></i>{" "}
                            <span className="mx-2">Add Branch</span>
                          </>
                        )}
                      </Button>

                      {(hasAnyAddError() || showAddValidationError) && (
                        <div className="error-tooltip-wrapper">
                          <Button
                            style={{
                              backgroundColor: "#C21E22",
                              border: "#f82e2e",
                            }}
                            title="Show Errors"
                            className="mx-2"
                            onClick={handleAddCheckValidationClick}
                            onMouseLeave={() =>
                              setIsAddValidationErrorVisible(false)
                            }
                          >
                            <i className="fa fa-exclamation"></i>
                          </Button>
                          {isAddValidationErrorVisible && (
                            <div className="validation-error-tooltip">
                              <ul className="mb-0 px-4">
                                {buildAddErrorMessages().map((error, index) => (
                                  <li
                                    key={index}
                                    className="text-left small pb-0"
                                  >
                                    {error}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <span
                        className="btn btn-inox-green border-0"
                        style={{ width: 200 }}
                        onClick={handleNextClick}
                        disabled={activeStep === steps.length - 1}
                      >
                        Next
                      </span>
                      {isAddStepErrorVisible && addStepErrors.length > 0 && (
                        <div
                          className="error-tooltip-wrapper"
                          style={{ display: "inline-block" }}
                        >
                          <Button
                            style={{
                              backgroundColor: "#C21E22",
                              border: "#f82e2e",
                            }}
                            title="Show Errors"
                            className="mx-2"
                            onClick={() =>
                              setIsAddStepErrorVisible(!isAddStepErrorVisible)
                            }
                            onMouseLeave={() => setIsAddStepErrorVisible(false)}
                          >
                            <i className="fa fa-exclamation"></i>
                          </Button>
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {addStepErrors.map((error, index) => (
                                <li
                                  key={index}
                                  className="text-left small pb-0"
                                >
                                  {error}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* -------------------- End Add Canvas -------------------- */}
    </div>
  );
}

export default CustomerBranchMaster;
